// CommonFields.tsx
import React, { useState } from "react";
import {
  Input,
  Upload,
  Button,
  Typography,
  Form,
  Col,
  DatePicker,
  Select,
  Radio,
  Checkbox,
  Flex,
  Row,
  message,
  Table,
  Tooltip,
} from "antd";
import {
  UploadOutlined,
  DownloadOutlined,
  EyeOutlined,
  DeleteOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import { IDocumentFields } from "../../interfaces/ICase";
import { IDeficiencyCheck } from "../../interfaces/IPatient";
const { Text } = Typography;
const dateFormat = "DD-MM-YYYY HH:mm:ss";

interface FieldProps {
  field: any;
  index: number;
  isReadOnly: boolean;
  onFieldChange?: (index: number, id: string, value: string) => void;
  handleFileChange?: CallableFunction;
  showPreview?: (url: string, label: string) => void;
  value?: string | null;
  key?: string;
  form?: any;
  isFileUploadDisabled?: boolean;
  isAdditionalAmountPaid?: any;
  isTypeOfDischarge?: boolean;
  isRoutineDischarge?: boolean;
  isAssuredBy?: boolean;
  caseSubmissionId?: number | null;
  uploadedDocumentUrl?: Array<IDocumentFields>;
  viewFile?: CallableFunction;
  handleDeleteList?: CallableFunction;
  handleSetDocumentUrl?: CallableFunction;
  handleOpen?: any;
  treatingDoctorTypeOptions?: Array<{ label: string; value: string }>;
  doctorTypeNameList?: any;
  onKeyDown?: any;
  handleDownloadDocument?: CallableFunction;
  isDownloadingDocument?: boolean;
  downloadingDocumentUrl?: string;
  isClaimSubmission?: boolean;
  tabIndex?: number;
  handleDeficiencyModal?: any;
  closeDeficiencyModal?: any;
  deficiencyModal?: boolean;
  deficiencyQuestions?: any;
  previewDocumentUrl?: string;
  setDocumentName?: any;
  handleDeficiencyModalAfterSave?: any;
  starHealthRoomTypeOptions?: Array<{ id: number; roomType: string }> | null;
  totalClaimedAmount?: any;
  answersOfClinicalFindings?: any;
}

const DropdownWithFileUpload: React.FC<FieldProps> = ({
  field,
  index,
  isReadOnly,
  onFieldChange,
  handleFileChange,
  handleOpen,
  handleSetDocumentUrl,
  handleDownloadDocument,
  uploadedDocumentUrl,
  handleDeleteList,
}) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);

  return (
    <>
      <Col xs={24} sm={24} md={24} lg={11} xl={11}>
        <Form.Item
          key={field?.id}
          name={field?.id}
          label={field.label?.toUpperCase()}
          rules={[
            {
              required:
                field?.required && !(field?.dischargeDocumentList?.length > 0),
              message: `${field?.label} is required`,
            },
          ]}
        >
          <Select
            showSearch
            placeholder={`Select ${field?.label}`}
            options={field?.labelValues?.map((option: any) => ({
              value: option?.value,
              label: option?.label,
            }))}
            onChange={(value) => {
              setSelectedOption(value);
              onFieldChange && onFieldChange(index, field.id, value);
            }}
            disabled={isReadOnly}
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Col>
      {selectedOption && (
        <>
          <Col xs={24} sm={24} md={24} lg={11} xl={11}>
            <Form.Item
              key={`${field?.id}-upload`}
              name={`${field?.id}-upload`}
              rules={[
                {
                  required: field?.required,
                  message: `Document upload is required`,
                },
              ]}
            >
              <Upload
                id={`${field.id}-upload`}
                beforeUpload={() => false}
                maxCount={1}
                onChange={(info) =>
                  handleFileChange && handleFileChange(selectedOption)(info)
                }
                showUploadList={false}
                disabled={isReadOnly}
                style={{ width: "100%" }}
              >
                <Button
                  icon={<UploadOutlined />}
                  style={{ marginLeft: "10px", width: "100%" }}
                  disabled={isReadOnly}
                >
                  SELECT FILE
                </Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col xs={24} md={24} sm={24} lg={24} xl={24}>
            {uploadedDocumentUrl &&
              uploadedDocumentUrl?.length > 0 &&
              uploadedDocumentUrl?.map((document, i) => (
                <div className="file-list-container" key={i}>
                  <ul className="list-unstyled" style={{ marginTop: "0rem" }}>
                    <li className="file-item" style={{ display: "flex" }}>
                      <span className="file-name" style={{ width: "25%" }}>
                        {document?.documentType}
                      </span>
                      <span className="file-name" style={{ width: "30%" }}>
                        {document?.documentName
                          ? document?.documentName.length > 20
                            ? document?.documentName?.substring(0, 20) + "..."
                            : document?.documentName
                          : ""}
                      </span>

                      <Flex
                        // justify="flex-end"
                        align="center"
                        gap="small"
                        className="fa-icons"
                        style={{ width: "10%" }}
                      >
                        <Button
                          shape="circle"
                          icon={<DownloadOutlined />}
                          onClick={() =>
                            handleDownloadDocument &&
                            handleDownloadDocument(
                              document?.documentName,
                              document?.documentUrl
                            )
                          }
                        />

                        <Button
                          shape="circle"
                          icon={<EyeOutlined />}
                          onClick={() => {
                            handleOpen && handleOpen();
                            handleSetDocumentUrl &&
                              handleSetDocumentUrl(document?.documentUrl);
                          }}
                        />

                        <Button
                          shape="circle"
                          icon={<DeleteOutlined />}
                          onClick={() =>
                            handleDeleteList &&
                            handleDeleteList(
                              document?.documentLabelType,
                              document?.documentUrl,
                              i
                            )
                          }
                        />
                      </Flex>
                    </li>
                  </ul>
                </div>
              ))}
          </Col>
        </>
      )}
      <Col xs={24} md={24} sm={24} lg={24} xl={24}>
        {field &&
          field?.dischargeDocumentList?.length > 0 &&
          field?.dischargeDocumentList?.map((document: any, i: number) => {
            return (
              <div className="file-list-container" key={i}>
                <ul className="list-unstyled" style={{ marginTop: "0rem" }}>
                  <li className="file-item" style={{ display: "flex" }}>
                    <span className="file-name" style={{ width: "25%" }}>
                      {document?.documentType}
                    </span>
                    <span className="file-name" style={{ width: "30%" }}>
                      {document?.documentName
                        ? document?.documentName?.length > 20
                          ? document?.documentName?.substring(0, 20) + "..."
                          : document?.documentName
                        : ""}
                    </span>

                    <Flex
                      // justify="flex-end"
                      align="center"
                      gap="small"
                      className="fa-icons"
                      style={{ width: "10%" }}
                    >
                      <Button
                        shape="circle"
                        icon={<DownloadOutlined />}
                        onClick={() =>
                          handleDownloadDocument &&
                          handleDownloadDocument(
                            document?.documentName,
                            document?.documentUrl
                          )
                        }
                      />

                      <Button
                        shape="circle"
                        icon={<EyeOutlined />}
                        onClick={() => {
                          handleOpen && handleOpen();
                          handleSetDocumentUrl &&
                            handleSetDocumentUrl(document?.documentUrl);
                        }}
                      />

                      <Button
                        shape="circle"
                        icon={<DeleteOutlined />}
                        onClick={() =>
                          handleDeleteList &&
                          handleDeleteList(
                            document?.documentLabelType,
                            document?.documentUrl,
                            i
                          )
                        }
                        disabled={isReadOnly}
                      />
                    </Flex>
                  </li>
                </ul>
              </div>
            );
          })}
      </Col>
    </>
  );
};

export const renderCommonField = ({
  field,
  index,
  isReadOnly,
  onFieldChange,
  handleFileChange,
  showPreview,
  value,
  key,
  form,
  isFileUploadDisabled,
  isAdditionalAmountPaid,
  isTypeOfDischarge,
  isRoutineDischarge,
  isAssuredBy,
  caseSubmissionId,
  uploadedDocumentUrl,
  viewFile,
  handleDeleteList,
  handleSetDocumentUrl,
  handleOpen,
  treatingDoctorTypeOptions,
  doctorTypeNameList,
  onKeyDown,
  handleDownloadDocument,
  isClaimSubmission,
  tabIndex,
  handleDeficiencyModal,
  closeDeficiencyModal,
  deficiencyModal,
  deficiencyQuestions,
  previewDocumentUrl,
  setDocumentName,
  handleDeficiencyModalAfterSave,
  starHealthRoomTypeOptions,
  totalClaimedAmount,
  answersOfClinicalFindings,
  isDownloadingDocument,
  downloadingDocumentUrl
}: FieldProps) => {
  if (key && key.includes("ihx")) {
    const allowedFileTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/bmp",
      "image/webp",
      "application/pdf",
    ];

    const maxFileSize = 15 * 1024 * 1024;

    const beforeUpload = (file: any) => {
      if (!allowedFileTypes.includes(file?.type)) {
        message.error(
          "You can only upload image files (JPEG, PNG, GIF, BMP, WebP) or PDF files!"
        );
        return Upload.LIST_IGNORE;
      }
      if (file.size > maxFileSize) {
        message.error("File must be smaller than 15 MB!");
        return Upload.LIST_IGNORE;
      }
      return false;
    };

    switch (field.type) {
      case "input":
        if (field.id === "amount" && isAdditionalAmountPaid) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                wrapperCol={{ span: 8 }}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
                style={{ fontWeight: "600" }}
              >
                <Input
                  defaultValue={field?.data || ""}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                  // style={{ color: "rgb(132 127 127" }}
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        } else if (field?.id === "amount" && !isAdditionalAmountPaid)
          return null;
        else if (field?.id !== "amount") {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                // name={field?.id}
                label={field.label?.toUpperCase()}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
                style={{ fontWeight: "600" }}
              >
                <Input
                  defaultValue={field?.data || ""}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        }
        return null;
      // case "calendar-show":
      case "text-show":
        // if (field.id === "dateOfDischarge" || "DateOfDischarge") {
        if (field.id === "dateOfAdmission" || field.id === "dateOfDischarge") {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field.id}
                label={field.label}
                name={field.id}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
                style={{ marginBottom: "8px", fontWeight: "600" }}
              >
                {isReadOnly ? (
                  <div style={{ color: "#949494" }}>
                    {/^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/.test(field?.data)
                      ? field?.data
                      : field?.data
                      ? dayjs(field.data).format("DD-MM-YYYY HH:mm:ss")
                      : "No Date Available"}
                  </div>
                ) : (
                  <DatePicker
                    id={field.id}
                    defaultValue={
                      field?.data ? dayjs(field?.data, dateFormat) : null
                    }
                    showTime
                    format={dateFormat}
                    // value={dayjs(field.data, dateFormat)}
                    onChange={(date, dateString) =>
                      onFieldChange &&
                      onFieldChange(index, field.id, dateString as string)
                    }
                  />
                )}
              </Form.Item>
            </Col>
          );
        }

        return (
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Form.Item
              initialValue={value || field.data || ""}
              key={field.id}
              name={field.id}
              label={field.label}
              rules={[
                {
                  required: field?.required,
                  message: `${field?.label} is required`,
                },
                // Additional rule to check for numeric input
                ...([
                  "packages",
                  "roomRentAndNursingCharge",
                  "consultation",
                  "otCharge",
                  "surgeonAndAnesthetist",
                  "investigation",
                  "medicineAndConsumables",
                  "otherHospitalExpenses",
                  "patientPaidAmount",
                ].includes(field.id)
                  ? [
                      {
                        pattern: /^\d+$/,
                        message: `${field?.label} must be a number`,
                      },
                    ]
                  : []),
              ]}
              style={{ marginBottom: "8px", fontWeight: "600" }}
            >
              {isReadOnly ||
              field.id === "ReceivedQuery" ||
              field?.id === "dateOfAdmission" ? (
                <div style={{ color: "#949494" }}>{value || field.data}</div>
              ) : (
                <Input
                  type="text"
                  id={field.id}
                  defaultValue={field?.data || ""}
                  placeholder="Enter Your Response here..."
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                />
              )}
            </Form.Item>
          </Col>
        );

      case "document-upload":
        return (
          <>
            {key && key.includes("ihxClaimSubmissionResponses") ? (
              <Row style={{ width: "100%" }}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item
                    // valuePropName="fileList"
                    label={
                      field.label?.toUpperCase() || field.id?.toUpperCase()
                    }
                    // getValueFromEvent={(e) => e?.fileList}
                    name={field?.id}
                    rules={[
                      {
                        required:
                          uploadedDocumentUrl &&
                          uploadedDocumentUrl?.length < 1 &&
                          field?.required,
                        message: "Please upload a file",
                      },
                    ]}
                    style={{
                      marginBottom: "8px",
                      fontWeight: "600",
                      color: "#949494",
                    }}
                  >
                    <Upload
                      id={field.id}
                      accept="image/*,.pdf"
                      beforeUpload={beforeUpload}
                      // maxCount={5}
                      multiple={true} // Allow multiple file uploads
                      showUploadList={false}
                      onChange={
                        handleFileChange &&
                        handleFileChange(field?.labelId, field?.label)
                      }
                      disabled={isFileUploadDisabled} // Use the new prop here
                    >
                      <Button
                        icon={<UploadOutlined />}
                        style={{
                          marginLeft: "10px",
                          width: "100%",
                          color: "#949494",
                        }}
                        disabled={isFileUploadDisabled}
                      >
                        SELECT FILE
                      </Button>
                      <div
                        className="file-type-info"
                        style={{ marginTop: "10px", textAlign: "center" }}
                      >
                        <Text type="secondary">
                          <FileImageOutlined /> Images (JPEG, PNG, GIF, BMP,
                          WebP) or <FilePdfOutlined /> PDF only
                        </Text>
                      </div>
                      <div
                        className="file-limit-info"
                        style={{ marginTop: "5px", textAlign: "center" }}
                      ></div>
                    </Upload>
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={24}
                  sm={24}
                  lg={24}
                  xl={24}
                  style={{ marginBottom: "0.4rem" }}
                >
                  {uploadedDocumentUrl && uploadedDocumentUrl?.length > 0 && (
                    <Table
                      showHeader={false}
                      dataSource={uploadedDocumentUrl?.filter(
                        (doc) =>
                          doc?.documentLabelType === field?.label &&
                          doc?.prefilledData !== true
                      )}
                      columns={[
                        {
                          title: "Document Type",
                          dataIndex: "documentLabelType",
                          key: "documentType",
                          width: "30%",
                          render: (type: string) => (
                            <Flex justify="center">
                              <Text style={{ color: "#7c8181" }}>{type}</Text>
                            </Flex>
                          ),
                        },
                        {
                          title: "Document Name",
                          dataIndex: "documentName",
                          key: "documentName",
                          width: "30%",

                          render: (name: string) => (
                            <Flex justify="center">
                              <Tooltip title={name}>
                                <Text strong style={{ color: "#7c8181" }}>
                                  {name?.length > 20
                                    ? name?.substring(0, 20) + "..."
                                    : name}
                                </Text>
                              </Tooltip>
                            </Flex>
                          ),
                          // width: 520,
                        },
                        {
                          title: "Actions",
                          key: "actions",
                          width: "40%",
                          render: (_, document, i) => (
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                              }}
                            >
                              {isDownloadingDocument && downloadingDocumentUrl === document?.documentUrl ? <LoadingOutlined style={{color: "#273881", fontSize: "18px"}}/> :
                                <Tooltip title="Download File">
                                  <DownloadOutlined
                                    style={{
                                      color: "#273881",
                                      fontSize: "18px",
                                    }}
                                    onClick={() =>
                                      handleDownloadDocument &&
                                      handleDownloadDocument(
                                        document?.documentName,
                                        document?.documentUrl
                                      )
                                    }
                                  />
                                </Tooltip>
                              }
                              <Tooltip title="View File">
                                <EyeOutlined
                                  style={{
                                    color: "#273881",
                                    fontSize: "18px",
                                  }}
                                  onClick={() => {
                                    handleOpen && handleOpen();
                                    handleSetDocumentUrl &&
                                      handleSetDocumentUrl(
                                        document?.documentUrl
                                      );
                                  }}
                                />
                              </Tooltip>
                              <Tooltip title="Delete File">
                                <DeleteOutlined
                                  style={{
                                    color: "#273881",
                                    fontSize: "18px",
                                  }}
                                  onClick={() =>
                                    handleDeleteList &&
                                    handleDeleteList(
                                      document?.documentLabelType,
                                      document?.documentUrl,
                                      i
                                    )
                                  }
                                />
                              </Tooltip>
                              {document?.deficiencyCheckStatus ? (
                                <Button
                                  onClick={() => {
                                    if (document && document?.documentName) {
                                      setDocumentName(document?.documentName);
                                    }
                                    if (document?.documentType) {
                                      handleDeficiencyModal(
                                        document?.documentUrl,
                                        parseInt(document?.documentType),
                                        document
                                      );
                                    }
                                  }}
                                  type="primary"
                                  style={{
                                    backgroundColor: "rgb(0, 109, 119)",
                                  }}
                                >
                                  DEFICIENCY PASSED
                                </Button>
                              ) : document?.deficiencyCheckStatus === false ? (
                                <Button
                                  onClick={() => {
                                    if (document && document?.documentName) {
                                      setDocumentName(document?.documentName);
                                    }
                                    if (document?.documentType) {
                                      handleDeficiencyModal(
                                        document?.documentUrl,
                                        parseInt(document?.documentType),
                                        document
                                      );
                                    }
                                  }}
                                  type="primary"
                                  danger
                                >
                                  DEFICIENCY FAILED
                                </Button>
                              ) : (
                                (Array?.isArray(deficiencyQuestions) ||
                                  typeof deficiencyQuestions === "object") && (
                                  <Button
                                    onClick={() => {
                                      if (document && document?.documentName) {
                                        setDocumentName(document?.documentName);
                                      }
                                      if (document?.documentType) {
                                        handleDeficiencyModal(
                                          document?.documentUrl,
                                          parseInt(document?.documentType),
                                          document
                                        );
                                      }
                                    }}
                                    type="primary"
                                    htmlType="submit"
                                  >
                                    DEFICIENCY CHECK
                                  </Button>
                                )
                              )}
                            </div>
                          ),
                        },
                      ]}
                      rowKey={(record) =>
                        record.documentName || `document-${record.documentUrl}`
                      }
                      pagination={false}
                      className="showUploadDoc"
                    />
                  )}
                </Col>
              </Row>
            ) : (
              <Row style={{ width: "100%" }}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item
                    // valuePropName="fileList"
                    label={field.label?.toUpperCase()}
                    // getValueFromEvent={(e) => e?.fileList}
                    name={field.id}
                    rules={[
                      {
                        required: field?.required,
                        message: `${field?.label} is required`,
                      },
                    ]}
                    style={{
                      marginBottom: "8px",
                      fontWeight: "600",
                      color: "#949494",
                    }}
                  >
                    <Upload
                      id={field.id}
                      accept="image/*,.pdf"
                      beforeUpload={beforeUpload}
                      // maxCount={5}
                      multiple={true} // Allow multiple file uploads
                      showUploadList={false}
                      onChange={
                        handleFileChange &&
                        handleFileChange(field?.labelId, field?.label)
                      }
                      disabled={isFileUploadDisabled} // Use the new prop here
                    >
                      <Button
                        icon={<UploadOutlined />}
                        style={{
                          marginLeft: "10px",
                          width: "100%",
                          color: "#949494",
                        }}
                        disabled={isFileUploadDisabled}
                      >
                        SELECT FILE
                      </Button>
                      <div
                        className="file-type-info"
                        style={{ marginTop: "10px", textAlign: "center" }}
                      >
                        <Text type="secondary">
                          <FileImageOutlined /> Images (JPEG, PNG, GIF, BMP,
                          WebP) or <FilePdfOutlined /> PDF only
                        </Text>
                      </div>
                      {/* <div
                className="file-limit-info"
                style={{ marginTop: "5px", textAlign: "center" }}
              >
                <Text type="secondary">
                  Up to 5 files allowed, max 2 MB each
                </Text>
              </div> */}
                    </Upload>
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  md={24}
                  sm={24}
                  lg={24}
                  xl={24}
                  style={{ marginBottom: "0.4rem" }}
                >
                  {uploadedDocumentUrl && uploadedDocumentUrl?.length > 0 && (
                    <Table
                      showHeader={false}
                      dataSource={uploadedDocumentUrl?.filter(
                        (doc) =>
                          doc?.documentLabelType === field?.label &&
                          doc?.prefilledData !== true
                      )}
                      columns={[
                        {
                          title: "Document Type",
                          dataIndex: "documentLabelType",
                          key: "documentType",
                          width: "30%",
                          render: (type: string) => (
                            <Flex justify="center">
                              <Text style={{ color: "#7c8181" }}>{type}</Text>
                            </Flex>
                          ),
                        },
                        {
                          title: "Document Name",
                          dataIndex: "documentName",
                          key: "documentName",
                          width: "30%",

                          render: (name: string) => (
                            <Flex justify="center">
                              <Tooltip title={name}>
                                <Text strong style={{ color: "#7c8181" }}>
                                  {name?.length > 20
                                    ? name?.substring(0, 20) + "..."
                                    : name}
                                </Text>
                              </Tooltip>
                            </Flex>
                          ),
                          // width: 520,
                        },
                        {
                          title: "Actions",
                          key: "actions",
                          width: "40%",
                          render: (_, document, i) => (
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "center",
                              }}
                            >
                              {isDownloadingDocument && downloadingDocumentUrl === document?.documentUrl ? <LoadingOutlined style={{color: "#273881", fontSize: "18px"}}/> :
                                <Tooltip title="Download File">
                                  <DownloadOutlined
                                    style={{
                                      color: "#273881",
                                      fontSize: "18px",
                                    }}
                                    onClick={() =>
                                      handleDownloadDocument &&
                                      handleDownloadDocument(
                                        document?.documentName,
                                        document?.documentUrl
                                      )
                                    }
                                  />
                                </Tooltip>
                              }
                              <Tooltip title="View File">
                                <EyeOutlined
                                  style={{
                                    color: "#273881",
                                    fontSize: "18px",
                                  }}
                                  onClick={() => {
                                    handleOpen && handleOpen();
                                    handleSetDocumentUrl &&
                                      handleSetDocumentUrl(
                                        document?.documentUrl
                                      );
                                  }}
                                />
                              </Tooltip>
                              <Tooltip title="Delete File">
                                <DeleteOutlined
                                  style={{
                                    color: "#273881",
                                    fontSize: "18px",
                                  }}
                                  onClick={() =>
                                    handleDeleteList &&
                                    handleDeleteList(
                                      document?.documentLabelType,
                                      document?.documentUrl,
                                      i
                                    )
                                  }
                                />
                              </Tooltip>
                              {document?.deficiencyCheckStatus ? (
                                <Button
                                  onClick={() => {
                                    if (document && document?.documentName) {
                                      setDocumentName(document?.documentName);
                                    }
                                    if (document?.documentType) {
                                      handleDeficiencyModal(
                                        document?.documentUrl,
                                        parseInt(document?.documentType),
                                        document
                                      );
                                    }
                                  }}
                                  type="primary"
                                  style={{
                                    backgroundColor: "rgb(0, 109, 119)",
                                  }}
                                >
                                  DEFICIENCY PASSED
                                </Button>
                              ) : document?.deficiencyCheckStatus === false ? (
                                <Button
                                  onClick={() => {
                                    if (document && document?.documentName) {
                                      setDocumentName(document?.documentName);
                                    }
                                    if (document?.documentType) {
                                      handleDeficiencyModal(
                                        document?.documentUrl,
                                        parseInt(document?.documentType),
                                        document
                                      );
                                    }
                                  }}
                                  type="primary"
                                  danger
                                >
                                  DEFICIENCY FAILED
                                </Button>
                              ) : (
                                (Array?.isArray(deficiencyQuestions) ||
                                  typeof deficiencyQuestions === "object") && (
                                  <Button
                                    onClick={() => {
                                      if (document && document?.documentName) {
                                        setDocumentName(document?.documentName);
                                      }
                                      if (document?.documentType) {
                                        handleDeficiencyModal(
                                          document?.documentUrl,
                                          parseInt(document?.documentType),
                                          document
                                        );
                                      }
                                    }}
                                    type="primary"
                                    htmlType="submit"
                                  >
                                    DEFICIENCY CHECK
                                  </Button>
                                )
                              )}
                            </div>
                          ),
                        },
                      ]}
                      rowKey={(record) =>
                        record.documentName || `document-${record.documentUrl}`
                      }
                      pagination={false}
                      className="showUploadDoc"
                    />
                  )}
                </Col>
              </Row>
            )}
          </>
        );
      // case "document-show":
      //   return (
      //     <Col xs={24} sm={24} md={24} lg={24} xl={24}>
      //       <Form.Item
      //         key={field?.id}
      //         name={field?.id}
      //         label={field.label?.toUpperCase()}
      //         rules={[
      //           {
      //             required: field?.required,
      //             message: `${field?.label} is required`,
      //           },
      //         ]}
      //         style={{
      //           fontWeight: "600",
      //           color: "#949494",
      //         }}
      //       >
      //         {field?.data == null && field.id == "ReceivedDocQueryURL" ? (
      //           "N/A"
      //         ) : field?.data ? (
      //           <Flex align="center" justify="space-between" gap="small">
      //             {field?.documentName}
      //             <div style={{ display: "flex", gap: "5px" }}>
      //               <Button
      //                 key={field?.id}
      //                 shape="circle"
      //                 icon={<EyeOutlined />}
      //                 onClick={() => {
      //                   handleOpen && handleOpen();

      //                   handleSetDocumentUrl &&
      //                     handleSetDocumentUrl(field?.data);
      //                 }}
      //                 disabled={isClaimSubmission && !isReadOnly}
      //               />

      //               <Button
      //                 shape="circle"
      //                 icon={<DownloadOutlined />}
      //                 onClick={() => {
      //                   handleDownloadDocument &&
      //                     handleDownloadDocument(
      //                       field?.documentName,
      //                       field?.data
      //                     );
      //                 }}
      //                 disabled={isClaimSubmission && !isReadOnly}
      //               />

      //               {field?.deficiencyCheckStatus ? (
      //                 <Button
      //                   onClick={() => {
      //                     if (field && field?.documentName) {
      //                       setDocumentName(field?.documentName);
      //                     }
      //                     if (field?.labelId) {
      //                       handleDeficiencyModalAfterSave(
      //                         field?.data,
      //                         parseInt(field?.labelId),
      //                         field
      //                       );
      //                     }
      //                   }}
      //                   type="primary"
      //                   htmlType="submit"
      //                   style={{ backgroundColor: "rgb(0, 109, 119)" }}
      //                 >
      //                   DEFICIENCY PASSED
      //                 </Button>
      //               ) : field?.deficiencyCheckStatus === false ? (
      //                 <Button
      //                   onClick={() => {
      //                     if (field && field?.documentName) {
      //                       setDocumentName(field?.documentName);
      //                     }
      //                     if (field?.labelId) {
      //                       handleDeficiencyModalAfterSave(
      //                         field?.data,
      //                         parseInt(field?.labelId),
      //                         field
      //                       );
      //                     }
      //                   }}
      //                   type="primary"
      //                   danger
      //                   htmlType="submit"
      //                 >
      //                   DEFICIENCY FAILED
      //                 </Button>
      //               ) : (
      //                 (Array?.isArray(deficiencyQuestions) ||
      //                   typeof deficiencyQuestions === "object") && (
      //                   <Button
      //                     onClick={() => {
      //                       if (field && field?.documentName) {
      //                         setDocumentName(field?.documentName);
      //                       }
      //                       if (field?.labelId) {
      //                         handleDeficiencyModal(
      //                           field?.documentUrl,
      //                           parseInt(field?.labelId),
      //                           document
      //                         );
      //                       }
      //                     }}
      //                     type="primary"
      //                   >
      //                     DEFICIENCY CHECK
      //                   </Button>
      //                 )
      //               )}

      //               {/* {isClaimSubmission && (
      //                 <Button
      //                   shape="circle"
      //                   icon={<DeleteOutlined />}
      //                   onClick={() => {
      //                     handleDeleteList &&
      //                       handleDeleteList(field?.type, index);
      //                   }}
      //                   disabled={isReadOnly}
      //                 />
      //               )} */}
      //             </div>
      //           </Flex>
      //         ) : (
      //           <Upload
      //             id={field.id}
      //             beforeUpload={() => false}
      //             maxCount={1}
      //             onChange={
      //               handleFileChange &&
      //               handleFileChange(field?.labelId, field?.label)
      //             }
      //             showUploadList={false}
      //             disabled={isReadOnly}
      //           >
      //             <Button
      //               icon={<UploadOutlined />}
      //               style={{ marginLeft: "10px", width: "100%" }}
      //               disabled={isReadOnly}
      //             >
      //               SELECT FILE
      //             </Button>
      //           </Upload>
      //         )}
      //       </Form.Item>
      //     </Col>
      //   );

      case "document-show":
        return (
          <>
          {
            key && key.includes("ihxEnhancementResponses") ? 
            <Row style={{ width: "100%" }}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={
                  <>
                  <div style={{fontWeight:"500"}}>
                    {uploadedDocumentUrl?.find(
                      (doc) => doc?.documentLabelType === field?.label
                    ) && field?.required ? (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span
                          style={{
                            display: "inline-block",
                            marginInlineEnd: "4px",
                            color: "#ff4d4f",
                            fontSize: "14px",
                            fontFamily: "SimSun, sans-serif",
                            lineHeight: "1",
                          }}
                        >
                          *
                        </span>{" "}
                        {field.label?.toUpperCase()}
                      </div>
                    ) : (
                      field.label?.toUpperCase()
                    )}
                    </div>
                  </>
                }
                data-tab={tabIndex}
                rules={[
                  {
                    required:
                      !uploadedDocumentUrl?.find(
                        //field?.required
                        (doc) => doc?.documentLabelType === field?.label
                      ) && field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
                // rules={[
                //   {
                //     required: field?.required,
                //     message: `${field?.label} is required`,
                //   },
                // ]}
              >
                {uploadedDocumentUrl &&
                uploadedDocumentUrl?.length > 0 &&
                uploadedDocumentUrl?.find(
                  (doc) => doc?.documentLabelType === field?.label
                ) &&
                !field?.multiple ? (
                  <></>
                ) : (
                 <div>
                  {/* <Upload
                    id={field.id}
                    beforeUpload={() => false}
                    maxCount={1}
                    onChange={
                      handleFileChange &&
                      handleFileChange(field?.labelId, field?.label)
                    }
                    showUploadList={false}
                    disabled={isReadOnly}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      style={{
                        marginLeft: "10px",
                        width: "100%",
                        color: "#949494",
                      }}
                      disabled={isReadOnly}
                    >
                      SELECT FILE
                    </Button>
                    <div
                      className="file-type-info"
                      style={{ marginTop: "10px", textAlign: "center" }}
                    >
                      <Text type="secondary">
                        <FileImageOutlined /> Images (JPEG, PNG, GIF, BMP, WebP)
                        or <FilePdfOutlined /> PDF only
                      </Text>
                    </div>
                    <div
                      className="file-limit-info"
                      style={{ marginTop: "5px", textAlign: "center" }}
                    ></div>
                  </Upload> */}
                  </div>
                )}
              </Form.Item>
            </Col>
            <Col
              xs={24}
              md={24}
              sm={24}
              lg={24}
              xl={24}
              style={{ marginBottom: "0.4rem" }}
            >
              {field?.documentsList && field?.documentsList?.length > 0 && (
                <Table
                  showHeader={false}
                  dataSource={field?.documentsList}
                  columns={[
                    {
                      title: "Document Type",
                      dataIndex: "documentLabelType",
                      key: "documentType",
                      width: "30%",
                      render: (type: string) => (
                        <Flex justify="center">
                          <Text style={{ color: "#7c8181" }}>{type}</Text>
                        </Flex>
                      ),
                    },
                    {
                      title: "Document Name",
                      dataIndex: "documentName",
                      key: "documentName",
                      width: "30%",

                      render: (name: string) => (
                        <Flex justify="center">
                          <Tooltip title={name}>
                            <Text strong style={{ color: "#7c8181" }}>
                              {name?.length > 20
                                ? name?.substring(0, 20) + "..."
                                : name}
                            </Text>
                          </Tooltip>
                        </Flex>
                      ),
                      // width: 520,
                    },
                    {
                      title: "Actions",
                      key: "actions",
                      width: "40%",
                      render: (_, document, i) => (
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            justifyContent: "center",
                          }}
                        >
                          {isDownloadingDocument && downloadingDocumentUrl === document?.documentUrl ? <LoadingOutlined style={{color: "#273881", fontSize: "18px"}}/> :
                            <Tooltip title="Download File">
                              <DownloadOutlined
                                style={{
                                  color: "#273881",
                                  fontSize: "18px",
                                }}
                                onClick={() =>
                                  handleDownloadDocument &&
                                  handleDownloadDocument(
                                    document?.documentName,
                                    document?.documentUrl
                                  )
                                }
                              />
                            </Tooltip>
                          }
                          <Tooltip title="View File">
                            <EyeOutlined
                              style={{
                                color: "#273881",
                                fontSize: "18px",
                              }}
                              onClick={() => {
                                handleOpen && handleOpen();
                                handleSetDocumentUrl &&
                                  handleSetDocumentUrl(document?.documentUrl);
                              }}
                            />
                          </Tooltip>
                          <Tooltip title="Delete File">
                            <DeleteOutlined
                              style={{
                                color: isReadOnly ? "grey" : "#273881",
                                fontSize: "18px",
                                cursor: isReadOnly ? "not-allowed" : "pointer",
                              }}
                              onClick={
                                !isReadOnly
                                  ? () =>
                                      handleDeleteList &&
                                      handleDeleteList(
                                        document?.documentLabelType,
                                        document?.documentUrl,
                                        i
                                      )
                                  : undefined
                              }
                            />
                          </Tooltip>
                          {/* {document?.deficiencyCheckStatus ? (
                            <Button
                              onClick={() => {
                                if (document && document?.documentName) {
                                  setDocumentName(document?.documentName);
                                }
                                if (document?.documentType) {
                                  handleDeficiencyModal(
                                    document?.documentUrl,
                                    parseInt(document?.documentType),
                                    document
                                  );
                                }
                              }}
                              type="primary"
                              style={{ backgroundColor: "rgb(0, 109, 119)" }}
                            >
                              DEFICIENCY PASSED
                            </Button>
                          ) : document?.deficiencyCheckStatus === false ? (
                            <Button
                              onClick={() => {
                                if (document && document?.documentName) {
                                  setDocumentName(document?.documentName);
                                }
                                if (document?.documentType) {
                                  handleDeficiencyModal(
                                    document?.documentUrl,
                                    parseInt(document?.documentType),
                                    document
                                  );
                                }
                              }}
                              type="primary"
                              danger
                            >
                              DEFICIENCY FAILED
                            </Button>
                          ) : (
                            (Array?.isArray(deficiencyQuestions) ||
                              typeof deficiencyQuestions === "object") && (
                              <Button
                                onClick={() => {
                                  if (document && document?.documentName) {
                                    setDocumentName(document?.documentName);
                                  }
                                  if (document?.documentType) {
                                    handleDeficiencyModal(
                                      document?.documentUrl,
                                      parseInt(document?.documentType),
                                      document
                                    );
                                  }
                                }}
                                type="primary"
                              >
                                DEFICIENCY CHECK
                              </Button>
                            )
                          )} */}
                        </div>
                      ),
                    },
                  ]}
                  rowKey={(record) =>
                    record.documentName || `document-${record.documentUrl}`
                  }
                  pagination={false}
                  className="showUploadDoc"
                />
              )}
            </Col>
          </Row> : 
            <Row style={{ width: "100%" }}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={
                  <>
                    {uploadedDocumentUrl?.find(
                      (doc) => doc?.documentLabelType === field?.label
                    ) && field?.required ? (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span
                          style={{
                            display: "inline-block",
                            marginInlineEnd: "4px",
                            color: "#ff4d4f",
                            fontSize: "14px",
                            fontFamily: "SimSun, sans-serif",
                            lineHeight: "1",
                          }}
                        >
                          *
                        </span>{" "}
                        {field.label?.toUpperCase()}
                      </div>
                    ) : (
                      field.label?.toUpperCase()
                    )}
                  </>
                }
                data-tab={tabIndex}
                rules={[
                  {
                    required:
                      !uploadedDocumentUrl?.find(
                        //field?.required
                        (doc) => doc?.documentLabelType === field?.label
                      ) && field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
                // rules={[
                //   {
                //     required: field?.required,
                //     message: `${field?.label} is required`,
                //   },
                // ]}
              >
                {uploadedDocumentUrl &&
                uploadedDocumentUrl?.length > 0 &&
                uploadedDocumentUrl?.find(
                  (doc) => doc?.documentLabelType === field?.label
                ) &&
                !field?.multiple ? (
                  <></>
                ) : (
                  <Upload
                    id={field.id}
                    beforeUpload={() => false}
                    maxCount={1}
                    onChange={
                      handleFileChange &&
                      handleFileChange(field?.labelId, field?.label)
                    }
                    showUploadList={false}
                    disabled={isReadOnly}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      style={{
                        marginLeft: "10px",
                        width: "100%",
                        color: "#949494",
                      }}
                      disabled={isReadOnly}
                    >
                      SELECT FILE
                    </Button>
                    <div
                      className="file-type-info"
                      style={{ marginTop: "10px", textAlign: "center" }}
                    >
                      <Text type="secondary">
                        <FileImageOutlined /> Images (JPEG, PNG, GIF, BMP, WebP)
                        or <FilePdfOutlined /> PDF only
                      </Text>
                    </div>
                    <div
                      className="file-limit-info"
                      style={{ marginTop: "5px", textAlign: "center" }}
                    ></div>
                  </Upload>
                )}
              </Form.Item>
            </Col>
            <Col
              xs={24}
              md={24}
              sm={24}
              lg={24}
              xl={24}
              style={{ marginBottom: "0.4rem" }}
            >
              {uploadedDocumentUrl && uploadedDocumentUrl?.length > 0 && (
                <Table
                  showHeader={false}
                  dataSource={uploadedDocumentUrl?.filter(
                    (doc) => doc?.documentLabelType === field?.label
                  )}
                  columns={[
                    {
                      title: "Document Type",
                      dataIndex: "documentLabelType",
                      key: "documentType",
                      width: "30%",
                      render: (type: string) => (
                        <Flex justify="center">
                          <Text style={{ color: "#7c8181" }}>{type}</Text>
                        </Flex>
                      ),
                    },
                    {
                      title: "Document Name",
                      dataIndex: "documentName",
                      key: "documentName",
                      width: "30%",

                      render: (name: string) => (
                        <Flex justify="center">
                          <Tooltip title={name}>
                            <Text strong style={{ color: "#7c8181" }}>
                              {name?.length > 20
                                ? name?.substring(0, 20) + "..."
                                : name}
                            </Text>
                          </Tooltip>
                        </Flex>
                      ),
                      // width: 520,
                    },
                    {
                      title: "Actions",
                      key: "actions",
                      width: "40%",
                      render: (_, document, i) => (
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            justifyContent: "center",
                          }}
                        >
                          {isDownloadingDocument && downloadingDocumentUrl === document?.documentUrl ? <LoadingOutlined style={{color: "#273881", fontSize: "18px"}}/> :
                            <Tooltip title="Download File">
                              <DownloadOutlined
                                style={{
                                  color: "#273881",
                                  fontSize: "18px",
                                }}
                                onClick={() =>
                                  handleDownloadDocument &&
                                  handleDownloadDocument(
                                    document?.documentName,
                                    document?.documentUrl
                                  )
                                }
                              />
                            </Tooltip>
                          }
                          <Tooltip title="View File">
                            <EyeOutlined
                              style={{
                                color: "#273881",
                                fontSize: "18px",
                              }}
                              onClick={() => {
                                handleOpen && handleOpen();
                                handleSetDocumentUrl &&
                                  handleSetDocumentUrl(document?.documentUrl);
                              }}
                            />
                          </Tooltip>
                          <Tooltip title="Delete File">
                            <DeleteOutlined
                              style={{
                                color: isReadOnly ? "grey" : "#273881",
                                fontSize: "18px",
                                cursor: isReadOnly ? "not-allowed" : "pointer",
                              }}
                              onClick={
                                !isReadOnly
                                  ? () =>
                                      handleDeleteList &&
                                      handleDeleteList(
                                        document?.documentLabelType,
                                        document?.documentUrl,
                                        i
                                      )
                                  : undefined
                              }
                            />
                          </Tooltip>
                          {document?.deficiencyCheckStatus ? (
                            <Button
                              onClick={() => {
                                if (document && document?.documentName) {
                                  setDocumentName(document?.documentName);
                                }
                                if (document?.documentType) {
                                  handleDeficiencyModal(
                                    document?.documentUrl,
                                    parseInt(document?.documentType),
                                    document
                                  );
                                }
                              }}
                              type="primary"
                              style={{ backgroundColor: "rgb(0, 109, 119)" }}
                            >
                              DEFICIENCY PASSED
                            </Button>
                          ) : document?.deficiencyCheckStatus === false ? (
                            <Button
                              onClick={() => {
                                if (document && document?.documentName) {
                                  setDocumentName(document?.documentName);
                                }
                                if (document?.documentType) {
                                  handleDeficiencyModal(
                                    document?.documentUrl,
                                    parseInt(document?.documentType),
                                    document
                                  );
                                }
                              }}
                              type="primary"
                              danger
                            >
                              DEFICIENCY FAILED
                            </Button>
                          ) : (
                            (Array?.isArray(deficiencyQuestions) ||
                              typeof deficiencyQuestions === "object") && (
                              <Button
                                onClick={() => {
                                  if (document && document?.documentName) {
                                    setDocumentName(document?.documentName);
                                  }
                                  if (document?.documentType) {
                                    handleDeficiencyModal(
                                      document?.documentUrl,
                                      parseInt(document?.documentType),
                                      document
                                    );
                                  }
                                }}
                                type="primary"
                              >
                                DEFICIENCY CHECK
                              </Button>
                            )
                          )}
                        </div>
                      ),
                    },
                  ]}
                  rowKey={(record) =>
                    record.documentName || `document-${record.documentUrl}`
                  }
                  pagination={false}
                  className="showUploadDoc"
                />
              )}
            </Col>
          </Row>
          }
          </>
        );

      case "radio-button":
        return (
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Form.Item
              key={field?.id}
              name={field?.id}
              label={field.label?.toUpperCase()}
              rules={[
                {
                  required: field?.required,
                  message: `FIELD is required`,
                },
              ]}
              style={{ fontWeight: "600", color: "#949494" }}
            >
              <Radio.Group defaultValue={field?.data}>
                {field?.labelValues?.map(
                  (option: { label: string; value: string }) => (
                    <Radio
                      key={option.value}
                      value={option.value}
                      disabled={isReadOnly}
                      onChange={(e) =>
                        onFieldChange &&
                        onFieldChange(index, field?.id, e.target.value)
                      }
                      style={{ color: "#949494" }}
                    >
                      {option.label?.toUpperCase()}
                    </Radio>
                  )
                )}
              </Radio.Group>
            </Form.Item>
          </Col>
        );

      case "checkbox":
        if (field?.id === "checkbox1" && caseSubmissionId) {
          return null;
        } else {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                // label={field.label?.toUpperCase()}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
                style={{ fontWeight: "600" }}
              >
                <Checkbox
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.checked?.toString())
                  }
                >
                  {field?.label}
                </Checkbox>
              </Form.Item>
            </Col>
          );
        }
      case "calendar-show":
        if (
          field.id === "dateOfDischarge" ||
          "DateOfDischarge" ||
          "dateOfAdmission"
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field.id}
                label={field.label}
                name={field.id}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
                style={{ marginBottom: "8px", fontWeight: "600" }}
              >
                <div style={{ display: isReadOnly ? "none" : "block" }}>
                  {/* Editable mode */}
                  <DatePicker
                    id={field.id}
                    defaultValue={
                      field?.data ? dayjs(field?.data, dateFormat) : null
                    }
                    showTime
                    format={dateFormat}
                    onChange={(date, dateString) =>
                      onFieldChange &&
                      onFieldChange(index, field.id, dateString as string)
                    }
                  />
                </div>
                <div style={{ display: isReadOnly ? "block" : "none" }}>
                  <Text>
                    {/^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/.test(field?.data)
                      ? field.data
                      : field?.data
                      ? dayjs(field.data).format("DD-MM-YYYY HH:mm:ss")
                      : ""}
                  </Text>
                </div>
              </Form.Item>
            </Col>
          );
        }
        return (
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Form.Item
              initialValue={value || field.data || ""}
              key={field.id}
              label={field.label}
              rules={[
                {
                  required: field?.required,
                  message: `${field?.label} is required`,
                },
              ]}
              style={{ marginBottom: "8px" }}
            >
              {isReadOnly || field.id === "ReceivedQuery" ? (
                <Text>{value || field.data}</Text>
              ) : (
                <Input
                  type="text"
                  id={field.id}
                  defaultValue={field?.data || ""}
                  placeholder="Enter Your Response here..."
                  // value={value || field.data || ""}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                />
              )}
            </Form.Item>
          </Col>
        );

      default:
        return null;
    }
  } else if (key && (key?.includes("star") || key?.includes("echs"))) {
    switch (field.type) {
      case "input":
        if (
          (field.id === "amount" && isAdditionalAmountPaid) ||
          (field.id === "nameOfAssurer" && isAssuredBy) ||
          (field.id === "designationOfAssurer" && isAssuredBy) ||
          (field.id === "relationOfPatientToAssurer" && isAssuredBy) ||
          (field.id === "assuredBy" && !isAssuredBy)
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                wrapperCol={{ span: 8 }}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
                style={{ fontWeight: "600" }}
              >
                <Input
                  defaultValue={field?.data || ""}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                  // style={{ color: "rgb(132 127 127" }}
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        } else if (
          (field?.id === "amount" && !isAdditionalAmountPaid) ||
          (field.id === "nameOfAssurer" && !isAssuredBy) ||
          (field.id === "designationOfAssurer" && !isAssuredBy) ||
          (field.id === "relationOfPatientToAssurer" && !isAssuredBy)
        )
          return null;
        else if (
          field?.id?.toLowerCase()?.includes("amount") ||
          field?.id?.toLowerCase()?.includes("nameofassurer") ||
          field?.id?.toLowerCase()?.includes("designationofassurer") ||
          field?.id?.toLowerCase()?.includes("relationofpatienttoassurer")
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
                style={{ fontWeight: "600" }}
              >
                <Input
                  defaultValue={field?.data || ""}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        } else {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
                style={{ fontWeight: "600" }}
              >
                <Input
                  defaultValue={field?.data || ""}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        }

      // case "calendar-show":
      case "text-show":
        if (field?.id === "claimedAmount") {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                wrapperCol={{ span: 8 }}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                  {
                    pattern: /^\d+$/,
                    message: "Numeric values are allow!",
                  },
                  {
                    validator: async (_, value) => {
                      if (parseFloat(totalClaimedAmount) > 0) {
                        if (
                          value &&
                          parseFloat(value) > parseFloat(totalClaimedAmount)
                        ) {
                          return Promise.reject(
                            new Error(
                              `Claimed Amount must be lesser than or equal to ${totalClaimedAmount}`
                            )
                          );
                        }
                      }
                    },
                  },
                ]}
                style={{ fontWeight: "600" }}
              >
                <Input
                  defaultValue={field?.data || totalClaimedAmount}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                  // style={{ color: "rgb(132 127 127" }}
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        } else if (field?.id?.toLowerCase()?.includes("amount")) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                // wrapperCol={{ span: 8 }}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                  {
                    pattern: /^\d+$/,
                    message: "Numeric values are allow!",
                  },
                ]}
                style={{ fontWeight: "600" }}
              >
                <Input
                  defaultValue={field?.data || ""}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                  // style={{ color: "rgb(132 127 127" }}
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        } else if (
          field.id === "dateOfAdmission" ||
          field?.id === "billDate" ||
          field?.id === "doa" ||
          field?.id === "dod"
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field.id}
                name={field?.id}
                label={field.label}
                rules={[
                  {
                    required: field?.required,
                    message: "This field is required",
                  },
                ]}
                style={{ marginBottom: "8px", fontWeight: "600" }}
              >
                {isReadOnly ? (
                  <div style={{ color: "#949494" }}>
                    {/^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/.test(field?.data)
                      ? field.data
                      : field?.data
                      ? dayjs(field?.data).format("DD-MM-YYYY HH:mm:ss")
                      : "No Date Available"}
                  </div>
                ) : (
                  <DatePicker
                    id={field.id}
                    // defaultValue={
                    //   field?.data ? dayjs(field?.data).format("DD-MM-YYYY HH:mm:ss") : null
                    // }
                    showTime
                    format={dateFormat}
                    value={field?.data ? dayjs(field.data, dateFormat) : null}
                    onChange={(date, dateString) =>
                      onFieldChange &&
                      onFieldChange(index, field.id, dateString as string)
                    }
                  />
                )}
              </Form.Item>
            </Col>
          );
        } else if (field?.id === "dateOfDischarge") {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field.id}
                name={field?.id}
                label={field.label}
                rules={[
                  {
                    required: field?.required,
                    message: "This field is required",
                  },
                ]}
                style={{ marginBottom: "8px", fontWeight: "600" }}
              >
                {isReadOnly ? (
                  <div style={{ color: "#949494" }}>
                    {/^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/.test(field?.data)
                      ? field.data
                      : field?.data
                      ? dayjs(field?.data).format("DD-MM-YYYY HH:mm:ss")
                      : "No Date Available"}
                  </div>
                ) : (
                  <DatePicker
                    id={field.id}
                    // defaultValue={
                    //   field?.data ? dayjs(field?.data).format("DD-MM-YYYY HH:mm:ss") : null
                    // }
                    showTime
                    format={dateFormat}
                    value={field?.data ? dayjs(field.data, dateFormat) : null}
                    onChange={(date, dateString) =>
                      onFieldChange &&
                      onFieldChange(index, field.id, dateString as string)
                    }
                    disabledDate={(current) => {
                      return current && current < dayjs();
                    }}
                  />
                )}
              </Form.Item>
            </Col>
          );
        } else if (
          (field.id === "nameOfAssurer" && !isAssuredBy) ||
          (field.id === "designationOfAssurer" && !isAssuredBy) ||
          (field.id === "relationOfPatientToAssurer" && !isAssuredBy)
        )
          return null;
        else if (
          (field.id === "nameOfAssurer" && isAssuredBy) ||
          (field.id === "designationOfAssurer" && isAssuredBy) ||
          (field.id === "relationOfPatientToAssurer" && isAssuredBy)
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                initialValue={value || field.data || ""}
                key={field.id}
                name={field?.id}
                label={field.label}
                rules={[
                  {
                    required: field?.required,
                    message: "This field is required",
                  },
                ]}
                style={{ marginBottom: "8px", fontWeight: "600" }}
              >
                {isReadOnly ? (
                  <div style={{ color: "#949494" }}>{value || field.data}</div>
                ) : (
                  <Input
                    type="text"
                    id={field.id}
                    defaultValue={field?.data || ""}
                    placeholder="Enter Your Response here..."
                    // value={value || field.data || ""}
                    onChange={(e) =>
                      onFieldChange &&
                      onFieldChange(index, field.id, e.target.value)
                    }
                  />
                )}
              </Form.Item>
            </Col>
          );
        } else if (
          field?.id?.toLowerCase()?.includes("amount") ||
          field?.id?.toLowerCase()?.includes("nameofassurer") ||
          field?.id?.toLowerCase()?.includes("designationofassurer") ||
          field?.id?.toLowerCase()?.includes("relationofpatienttoassurer")
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                initialValue={value || field.data || ""}
                key={field.id}
                name={field?.id}
                label={field.label}
                rules={[
                  {
                    required: field?.required,
                    message: "This field is required",
                  },
                ]}
                style={{ marginBottom: "8px", fontWeight: "600" }}
              >
                {isReadOnly ? (
                  <div style={{ color: "#949494" }}>{value || field.data}</div>
                ) : (
                  <Input
                    type="text"
                    id={field.id}
                    defaultValue={field?.data || ""}
                    placeholder="Enter Your Response here..."
                    // value={value || field.data || ""}
                    onChange={(e) =>
                      onFieldChange &&
                      onFieldChange(index, field.id, e.target.value)
                    }
                  />
                )}
              </Form.Item>
            </Col>
          );
        } else if (
          (field?.id === "investigationsValue" &&
            answersOfClinicalFindings["investigations"] !== "Yes") ||
          (field?.id === "intensiveCareValue" &&
            answersOfClinicalFindings["intensiveCare"] !== "Yes") ||
          (field?.id === "medicalManagementValue" &&
            answersOfClinicalFindings["medicalManagement"] !== "Yes") ||
          (field?.id === "surgicalManagementValue" &&
            answersOfClinicalFindings["surgicalManagement"] !== "Yes") ||
          (field?.id === "procedureDescriptionMajorValue" &&
            answersOfClinicalFindings["procedureDescriptionMajor"] !== "Yes") ||
          (field?.id === "procedureDescriptionMinorValue" &&
            answersOfClinicalFindings["procedureDescriptionMinor"] !== "Yes") ||
          (field?.id === "otherTreatmentValue" &&
            answersOfClinicalFindings["otherTreatment"] !== "Yes")
        ) {
          return null;
        } else {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                initialValue={value || field.data || ""}
                key={field.id}
                name={field?.id}
                label={field.label}
                rules={[
                  {
                    required: field?.required,
                    message: "This field is required",
                  },
                ]}
                style={{ marginBottom: "8px", fontWeight: "600" }}
              >
                {isReadOnly ? (
                  <div style={{ color: "#949494" }}>{value || field.data}</div>
                ) : (
                  <Input
                    type="text"
                    id={field.id}
                    defaultValue={field?.data || ""}
                    placeholder="Enter Your Response here..."
                    // value={value || field.data || ""}
                    onChange={(e) =>
                      onFieldChange &&
                      onFieldChange(index, field.id, e.target.value)
                    }
                  />
                )}
              </Form.Item>
            </Col>
          );
        }

      case "document-upload":
        return (
          <Row style={{ width: "100%" }}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field?.label?.toUpperCase()}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
                style={{ fontWeight: "600" }}
              >
                {field?.data ? (
                  <Flex align="center" justify="space-between" gap="small">
                    {field?.documentName}
                    <div>
                      <EyeOutlined
                        style={{
                          color: "#273881",
                          fontSize: "18px",
                          marginRight: "4px",
                        }}
                        onClick={() => {
                          handleOpen && handleOpen();
                          handleSetDocumentUrl &&
                            handleSetDocumentUrl(field?.data);
                        }}
                      />
                      {isDownloadingDocument && downloadingDocumentUrl === field?.data ? <LoadingOutlined style={{color: "#273881", fontSize: "18px"}}/> :
                      <DownloadOutlined
                        style={{
                          color: "#273881",
                          fontSize: "18px",
                        }}
                        onClick={() => {
                          handleDownloadDocument &&
                            handleDownloadDocument(
                              field?.documentName,
                              field?.data
                            );
                        }}
                      />
    }
                      {/* <Button
                        type="link"
                        href={field.data ?? undefined}
                        target="_blank"
                        download
                        icon={<DownloadOutlined />}
                      ></Button> */}
                    </div>
                  </Flex>
                ) : (
                  <Upload
                    id={field.id}
                    beforeUpload={() => false}
                    maxCount={1}
                    onChange={
                      handleFileChange &&
                      handleFileChange(field?.labelId, field?.label)
                    }
                    showUploadList={false}
                    disabled={isReadOnly}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      style={{ marginLeft: "10px", width: "100%" }}
                      disabled={isReadOnly}
                    >
                      SELECT FILE
                    </Button>
                  </Upload>
                )}
              </Form.Item>
            </Col>
            {key?.toLowerCase()?.includes("echs") ? (
              <Col xs={24} md={24} sm={24} lg={24} xl={24}>
                {uploadedDocumentUrl && uploadedDocumentUrl?.length > 0 && (
                  <Table
                    showHeader={false}
                    dataSource={uploadedDocumentUrl?.filter(
                      (doc) => doc?.documentLabelType === field?.label
                    )}
                    columns={[
                      {
                        title: "Document Type",
                        dataIndex: "documentLabelType",
                        key: "documentType",
                        width: "30%",
                        render: (type: string) => (
                          <Flex justify="center">
                            <Text style={{ color: "#7c8181" }}>{type}</Text>
                          </Flex>
                        ),
                      },
                      {
                        title: "Document Name",
                        dataIndex: "documentName",
                        key: "documentName",
                        width: "30%",

                        render: (name: string) => (
                          <Flex justify="center">
                            <Tooltip title={name}>
                              <Text strong style={{ color: "#7c8181" }}>
                                {name?.length > 20
                                  ? name?.substring(0, 20) + "..."
                                  : name}
                              </Text>
                            </Tooltip>
                          </Flex>
                        ),
                        // width: 520,
                      },
                      {
                        title: "Actions",
                        key: "actions",
                        width: "40%",
                        render: (_, document, i) => (
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              justifyContent: "center",
                            }}
                          >
                            {isDownloadingDocument && downloadingDocumentUrl === document?.documentUrl ? <LoadingOutlined style={{color: "#273881", fontSize: "18px"}}/> :
                              <Tooltip title="Download File">
                                <DownloadOutlined
                                  style={{
                                    color: "#273881",
                                    fontSize: "18px",
                                  }}
                                  onClick={() =>
                                    handleDownloadDocument &&
                                    handleDownloadDocument(
                                      document?.documentName,
                                      document?.documentUrl
                                    )
                                  }
                                />
                              </Tooltip>
                            }
                            <Tooltip title="View File">
                              <EyeOutlined
                                style={{
                                  color: "#273881",
                                  fontSize: "18px",
                                }}
                                onClick={() => {
                                  handleOpen && handleOpen();
                                  handleSetDocumentUrl &&
                                    handleSetDocumentUrl(document?.documentUrl);
                                }}
                              />
                            </Tooltip>
                            <Tooltip title="Delete File">
                              <DeleteOutlined
                                style={{
                                  color: isReadOnly ? "grey" : "#273881",
                                  fontSize: "18px",
                                  cursor: isReadOnly
                                    ? "not-allowed"
                                    : "pointer",
                                }}
                                onClick={
                                  !isReadOnly
                                    ? () =>
                                        handleDeleteList &&
                                        handleDeleteList(
                                          document?.documentLabelType,
                                          document?.documentUrl,
                                          i
                                        )
                                    : undefined
                                }
                              />
                            </Tooltip>
                            {document?.deficiencyCheckStatus ? (
                              <Button
                                onClick={() => {
                                  if (document && document?.documentName) {
                                    setDocumentName(document?.documentName);
                                  }
                                  if (document?.documentType) {
                                    handleDeficiencyModal(
                                      document?.documentUrl,
                                      parseInt(document?.documentType),
                                      document
                                    );
                                  }
                                }}
                                type="primary"
                                style={{ backgroundColor: "rgb(0, 109, 119)" }}
                              >
                                DEFICIENCY PASSED
                              </Button>
                            ) : document?.deficiencyCheckStatus === false ? (
                              <Button
                                onClick={() => {
                                  if (document && document?.documentName) {
                                    setDocumentName(document?.documentName);
                                  }
                                  if (document?.documentType) {
                                    handleDeficiencyModal(
                                      document?.documentUrl,
                                      parseInt(document?.documentType),
                                      document
                                    );
                                  }
                                }}
                                type="primary"
                                danger
                              >
                                DEFICIENCY FAILED
                              </Button>
                            ) : (
                              (Array?.isArray(deficiencyQuestions) ||
                                typeof deficiencyQuestions === "object") && (
                                <Button
                                  onClick={() => {
                                    if (document && document?.documentName) {
                                      setDocumentName(document?.documentName);
                                    }
                                    if (document?.documentType) {
                                      handleDeficiencyModal(
                                        document?.documentUrl,
                                        parseInt(document?.documentType),
                                        document
                                      );
                                    }
                                  }}
                                  type="primary"
                                >
                                  DEFICIENCY CHECK
                                </Button>
                              )
                            )}
                          </div>
                        ),
                      },
                    ]}
                    rowKey={(record) =>
                      record.documentName || `document-${record.documentUrl}`
                    }
                    pagination={false}
                    className="showUploadDoc"
                  />
                )}
              </Col>
            ) : (
              <Col xs={24} md={24} sm={24} lg={24} xl={24}>
                {uploadedDocumentUrl &&
                  uploadedDocumentUrl?.length > 0 &&
                  uploadedDocumentUrl
                    ?.filter(
                      (doc) =>
                        doc?.documentLabelType === field?.label &&
                        doc?.prefilledData !== true
                    )
                    ?.map((document, i) => (
                      <div className="file-list-container" key={i}>
                        <ul
                          className="list-unstyled"
                          style={{ marginTop: "0rem" }}
                        >
                          <li className="file-item" style={{ display: "flex" }}>
                            <span
                              className="file-name"
                              style={{ width: "30%" }}
                            >
                              {document?.documentName
                                ? document?.documentName?.length > 20
                                  ? document?.documentName?.substring(0, 20) +
                                    "..."
                                  : document?.documentName
                                : ""}
                            </span>

                            <Flex
                              // justify="flex-end"
                              align="center"
                              gap="small"
                              className="fa-icons"
                              style={{ width: "10%" }}
                            >
                              <Button
                                shape="circle"
                                loading={isDownloadingDocument && (downloadingDocumentUrl === document?.documentUrl)}
                                icon={
                                  <DownloadOutlined
                                    style={{
                                      color: "#273881",
                                      fontSize: "18px",
                                    }}
                                  />
                                }
                                onClick={() =>
                                  handleDownloadDocument &&
                                  handleDownloadDocument(
                                    document?.documentName,
                                    document?.documentUrl
                                  )
                                }
                              />
                              <Button
                                shape="circle"
                                icon={<EyeOutlined />}
                                onClick={() => {
                                  handleOpen && handleOpen();
                                  handleSetDocumentUrl &&
                                    handleSetDocumentUrl(document?.documentUrl);
                                }}
                              />
                              <Button
                                shape="circle"
                                icon={<DeleteOutlined />}
                                onClick={() =>
                                  handleDeleteList &&
                                  handleDeleteList(
                                    document?.documentLabelType,
                                    document?.documentUrl,
                                    i
                                  )
                                }
                              />
                              {document?.deficiencyCheckStatus ? (
                                <Button
                                  onClick={() => {
                                    if (document && document?.documentName) {
                                      setDocumentName(document?.documentName);
                                    }
                                    if (document?.documentType) {
                                      handleDeficiencyModal(
                                        document?.documentUrl,
                                        parseInt(document?.documentType),
                                        document
                                      );
                                    }
                                  }}
                                  type="primary"
                                  style={{
                                    backgroundColor: "rgb(0, 109, 119)",
                                  }}
                                >
                                  DEFICIENCY PASSED
                                </Button>
                              ) : document?.deficiencyCheckStatus === false ? (
                                <Button
                                  onClick={() => {
                                    if (document && document?.documentName) {
                                      setDocumentName(document?.documentName);
                                    }
                                    if (document?.documentType) {
                                      handleDeficiencyModal(
                                        document?.documentUrl,
                                        parseInt(document?.documentType),
                                        document
                                      );
                                    }
                                  }}
                                  type="primary"
                                  danger
                                >
                                  DEFICIENCY FAILED
                                </Button>
                              ) : (
                                (Array?.isArray(deficiencyQuestions) ||
                                  typeof deficiencyQuestions === "object") && (
                                  <Button
                                    onClick={() => {
                                      if (document && document?.documentName) {
                                        setDocumentName(document?.documentName);
                                      }
                                      if (document?.documentType) {
                                        handleDeficiencyModal(
                                          document?.documentUrl,
                                          parseInt(document?.documentType),
                                          document
                                        );
                                      }
                                    }}
                                    type="primary"
                                  >
                                    DEFICIENCY CHECK
                                  </Button>
                                )
                              )}
                            </Flex>
                          </li>
                        </ul>
                      </div>
                    ))}
              </Col>
            )}
          </Row>
        );

      // case "document-show":
      //   return (
      //     <>
      //       {key?.toLowerCase()?.includes("echs") ? (
      //         <Row style={{ width: "100%" }}>
      //           <Col xs={24} sm={24} md={24} lg={24} xl={24}>
      //             <Form.Item
      //               key={field?.id}
      //               name={field?.id}
      //               label={
      //                 <>
      //                   {uploadedDocumentUrl?.find(
      //                     (doc) => doc?.documentLabelType === field?.label
      //                   ) && field?.required ? (
      //                     <div
      //                       style={{
      //                         display: "flex",
      //                         alignItems: "center",
      //                         fontWeight: "600",
      //                       }}
      //                     >
      //                       <span
      //                         style={{
      //                           display: "inline-block",
      //                           marginInlineEnd: "4px",
      //                           color: "#ff4d4f",
      //                           fontSize: "14px",
      //                           fontFamily: "SimSun, sans-serif",
      //                           lineHeight: "1",
      //                         }}
      //                       >
      //                         *
      //                       </span>{" "}
      //                       {field.label?.toUpperCase()}
      //                     </div>
      //                   ) : (
      //                     <div
      //                       style={{
      //                         display: "flex",
      //                         alignItems: "center",
      //                         fontWeight: "600",
      //                       }}
      //                     >
      //                       {field.label?.toUpperCase()}
      //                     </div>
      //                   )}
      //                 </>
      //               }
      //               data-tab={tabIndex}
      //               rules={[
      //                 {
      //                   required:
      //                     !uploadedDocumentUrl?.find(
      //                       //field?.required
      //                       (doc) => doc?.documentLabelType === field?.label
      //                     ) && field?.required,
      //                   message: `${field?.label} is required`,
      //                 },
      //               ]}
      //               // rules={[
      //               //   {
      //               //     required: field?.required,
      //               //     message: `${field?.label} is required`,
      //               //   },
      //               // ]}
      //             >
      //               {uploadedDocumentUrl &&
      //               uploadedDocumentUrl?.length > 0 &&
      //               uploadedDocumentUrl?.find(
      //                 (doc) => doc?.documentLabelType === field?.label
      //               ) &&
      //               !field?.multiple ? (
      //                 <></>
      //               ) : (
      //                 <Upload
      //                   id={field.id}
      //                   beforeUpload={() => false}
      //                   maxCount={1}
      //                   onChange={
      //                     handleFileChange &&
      //                     handleFileChange(field?.labelId, field?.label)
      //                   }
      //                   showUploadList={false}
      //                   disabled={isReadOnly}
      //                 >
      //                   <Button
      //                     icon={<UploadOutlined />}
      //                     style={{ marginLeft: "10px", width: "100%" }}
      //                     disabled={isReadOnly}
      //                   >
      //                     SELECT FILE
      //                   </Button>
      //                 </Upload>
      //               )}
      //             </Form.Item>
      //           </Col>
      //           <Col
      //             xs={24}
      //             md={24}
      //             sm={24}
      //             lg={24}
      //             xl={24}
      //             style={{ marginBottom: "0.4rem" }}
      //           >
      //             {uploadedDocumentUrl && uploadedDocumentUrl?.length > 0 && (
      //               <Table
      //                 showHeader={false}
      //                 dataSource={uploadedDocumentUrl?.filter(
      //                   (doc) => doc?.documentLabelType === field?.label
      //                 )}
      //                 columns={[
      //                   {
      //                     title: "Document Type",
      //                     dataIndex: "documentLabelType",
      //                     key: "documentType",
      //                     width: "30%",
      //                     render: (type: string) => (
      //                       <Flex justify="center">
      //                         <Text style={{ color: "#7c8181" }}>{type}</Text>
      //                       </Flex>
      //                     ),
      //                   },
      //                   {
      //                     title: "Document Name",
      //                     dataIndex: "documentName",
      //                     key: "documentName",
      //                     width: "30%",

      //                     render: (name: string) => (
      //                       <Flex justify="center">
      //                         <Tooltip title={name}>
      //                           <Text strong style={{ color: "#7c8181" }}>
      //                             {name?.length > 20
      //                               ? name?.substring(0, 20) + "..."
      //                               : name}
      //                           </Text>
      //                         </Tooltip>
      //                       </Flex>
      //                     ),
      //                     // width: 520,
      //                   },
      //                   {
      //                     title: "Actions",
      //                     key: "actions",
      //                     width: "40%",
      //                     render: (_, document, i) => (
      //                       <div
      //                         style={{
      //                           display: "flex",
      //                           gap: "10px",
      //                           justifyContent: "center",
      //                         }}
      //                       >
      //                         {
      //                           <Tooltip title="Download File">
      //                             <DownloadOutlined
      //                               style={{
      //                                 color: "#273881",
      //                                 fontSize: "18px",
      //                               }}
      //                               onClick={() =>
      //                                 handleDownloadDocument &&
      //                                 handleDownloadDocument(
      //                                   document?.documentName,
      //                                   document?.documentUrl
      //                                 )
      //                               }
      //                             />
      //                           </Tooltip>
      //                         }
      //                         <Tooltip title="View File">
      //                           <EyeOutlined
      //                             style={{
      //                               color: "#273881",
      //                               fontSize: "18px",
      //                             }}
      //                             onClick={() => {
      //                               handleOpen && handleOpen();
      //                               handleSetDocumentUrl &&
      //                                 handleSetDocumentUrl(
      //                                   document?.documentUrl
      //                                 );
      //                             }}
      //                           />
      //                         </Tooltip>
      //                         {(document?.documentLabelType?.toLocaleUpperCase().includes("ECHS CARD") ||
      //                       document?.documentLabelType?.toLocaleUpperCase().includes("REFERRAL LETTER")) ?
      //                         <Tooltip title="Delete File">
      //                           <DeleteOutlined
      //                             style={{
      //                               color: "grey",
      //                               fontSize: "18px",
      //                               cursor: "not-allowed",
      //                             }}
      //                             onClick={undefined}
      //                           />
      //                         </Tooltip> : <Tooltip title="Delete File">
      //                           <DeleteOutlined
      //                             style={{
      //                               color: isReadOnly ? "grey" : "#273881",
      //                               fontSize: "18px",
      //                               cursor: isReadOnly
      //                                 ? "not-allowed"
      //                                 : "pointer",
      //                             }}
      //                             onClick={
      //                               !isReadOnly
      //                                 ? () =>
      //                                     handleDeleteList &&
      //                                     handleDeleteList(
      //                                       document?.documentLabelType,
      //                                       document?.documentUrl,
      //                                       i
      //                                     )
      //                                 : undefined
      //                             }
      //                           />
      //                         </Tooltip>
      //                   }
      //                         {document?.deficiencyCheckStatus ? (
      //                           <Button
      //                             onClick={() => {
      //                               if (document && document?.documentName) {
      //                                 setDocumentName(document?.documentName);
      //                               }
      //                               if (document?.documentType) {
      //                                 handleDeficiencyModal(
      //                                   document?.documentUrl,
      //                                   parseInt(document?.documentType),
      //                                   document
      //                                 );
      //                               }
      //                             }}
      //                             type="primary"
      //                             style={{
      //                               backgroundColor: "rgb(0, 109, 119)",
      //                             }}
      //                           >
      //                             DEFICIENCY PASSED
      //                           </Button>
      //                         ) : document?.deficiencyCheckStatus === false ? (
      //                           <Button
      //                             onClick={() => {
      //                               if (document && document?.documentName) {
      //                                 setDocumentName(document?.documentName);
      //                               }
      //                               if (document?.documentType) {
      //                                 handleDeficiencyModal(
      //                                   document?.documentUrl,
      //                                   parseInt(document?.documentType),
      //                                   document
      //                                 );
      //                               }
      //                             }}
      //                             type="primary"
      //                             danger
      //                           >
      //                             DEFICIENCY FAILED
      //                           </Button>
      //                         ) : (
      //                           (Array?.isArray(deficiencyQuestions) ||
      //                             typeof deficiencyQuestions === "object") && (
      //                             <Button
      //                               onClick={() => {
      //                                 if (document && document?.documentName) {
      //                                   setDocumentName(document?.documentName);
      //                                 }
      //                                 if (document?.documentType) {
      //                                   handleDeficiencyModal(
      //                                     document?.documentUrl,
      //                                     parseInt(document?.documentType),
      //                                     document
      //                                   );
      //                                 }
      //                               }}
      //                               type="primary"
      //                             >
      //                               DEFICIENCY CHECK
      //                             </Button>
      //                           )
      //                         )}
      //                       </div>
      //                     ),
      //                   },
      //                 ]}
      //                 rowKey={(record) =>
      //                   record.documentName || `document-${record.documentUrl}`
      //                 }
      //                 pagination={false}
      //                 className="showUploadDoc"
      //               />
      //             )}
      //           </Col>
      //         </Row>
      //       ) : (
      //         <Col xs={24} sm={24} md={24} lg={24} xl={24}>
      //           <Form.Item
      //             key={field?.id}
      //             name={field?.id}
      //             label={field.label?.toUpperCase()}
      //             rules={[
      //               {
      //                 required: field?.required,
      //                 message: `${field?.label} is required`,
      //               },
      //             ]}
      //             style={{
      //               fontWeight: "600",
      //               color: "#949494",
      //             }}
      //           >
      //             {field?.data ? (
      //               <Flex align="center" justify="space-between" gap="small">
      //                 {field?.documentName}
      //                 <div style={{ display: "flex", gap: "5px" }}>
      //                   <Button
      //                     shape="circle"
      //                     icon={<EyeOutlined />}
      //                     onClick={() => {
      //                       handleOpen && handleOpen();
      //                       handleSetDocumentUrl &&
      //                         handleSetDocumentUrl(field?.data);
      //                     }}
      //                     disabled={isClaimSubmission && isReadOnly}
      //                   />

      //                   <Button
      //                     shape="circle"
      //                     icon={<DownloadOutlined />}
      //                     onClick={() => {
      //                       handleDownloadDocument &&
      //                         handleDownloadDocument(field?.id, field?.data);
      //                     }}
      //                     disabled={isClaimSubmission && isReadOnly}
      //                   />
      //                   {field?.deficiencyCheckStatus ? (
      //                     <Button
      //                       onClick={() => {
      //                         if (field && field?.documentName) {
      //                           setDocumentName(field?.documentName);
      //                         }
      //                         if (field?.labelId) {
      //                           handleDeficiencyModalAfterSave(
      //                             field?.data,
      //                             parseInt(field?.labelId),
      //                             field
      //                           );
      //                         }
      //                       }}
      //                       type="primary"
      //                       htmlType="submit"
      //                       style={{ backgroundColor: "rgb(0, 109, 119)" }}
      //                     >
      //                       DEFICIENCY PASSED
      //                     </Button>
      //                   ) : field?.deficiencyCheckStatus === false ? (
      //                     <Button
      //                       onClick={() => {
      //                         if (field && field?.documentName) {
      //                           setDocumentName(field?.documentName);
      //                         }
      //                         if (field?.labelId) {
      //                           handleDeficiencyModalAfterSave(
      //                             field?.data,
      //                             parseInt(field?.labelId),
      //                             field
      //                           );
      //                         }
      //                       }}
      //                       type="primary"
      //                       danger
      //                       htmlType="submit"
      //                     >
      //                       DEFICIENCY FAILED
      //                     </Button>
      //                   ) : (
      //                     (Array?.isArray(deficiencyQuestions) ||
      //                       typeof deficiencyQuestions === "object") && (
      //                       <Button
      //                         onClick={() => {
      //                           if (field && field?.documentName) {
      //                             setDocumentName(field?.documentName);
      //                           }
      //                           if (field?.labelId) {
      //                             handleDeficiencyModalAfterSave(
      //                               field?.data,
      //                               parseInt(field?.labelId),
      //                               field
      //                             );
      //                           }
      //                         }}
      //                         type="primary"
      //                       >
      //                         DEFICIENCY CHECK
      //                       </Button>
      //                     )
      //                   )}
      //                 </div>
      //               </Flex>
      //             ) : (
      //               <Upload
      //                 id={field?.id}
      //                 beforeUpload={() => false}
      //                 maxCount={1}
      //                 onChange={
      //                   handleFileChange &&
      //                   handleFileChange(field?.labelId, field?.label)
      //                 }
      //                 showUploadList={false}
      //                 disabled={isReadOnly}
      //               >
      //                 <Button
      //                   icon={<UploadOutlined />}
      //                   style={{ marginLeft: "10px", width: "100%" }}
      //                   disabled={isReadOnly}
      //                 >
      //                   SELECT FILE
      //                 </Button>
      //               </Upload>
      //             )}
      //           </Form.Item>
      //         </Col>
      //       )}
      //     </>
      //   );

      case "document-show":
        return (
          <Row style={{ width: "100%" }}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={
                  <>
                    {uploadedDocumentUrl?.find(
                      (doc) => doc?.documentLabelType === field?.label
                    ) && field?.required ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontWeight: "600",
                        }}
                      >
                        <span
                          style={{
                            display: "inline-block",
                            marginInlineEnd: "4px",
                            color: "#ff4d4f",
                            fontSize: "14px",
                            fontFamily: "SimSun, sans-serif",
                            lineHeight: "1",
                          }}
                        >
                          *
                        </span>{" "}
                        {field.label?.toUpperCase()}
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontWeight: "600",
                        }}
                      >
                        {field.label?.toUpperCase()}
                      </div>
                    )}
                  </>
                }
                data-tab={tabIndex}
                rules={[
                  {
                    required:
                      !uploadedDocumentUrl?.find(
                        //field?.required
                        (doc) => doc?.documentLabelType === field?.label
                      ) && field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
                // rules={[
                //   {
                //     required: field?.required,
                //     message: `${field?.label} is required`,
                //   },
                // ]}
              >
                {uploadedDocumentUrl &&
                uploadedDocumentUrl?.length > 0 &&
                uploadedDocumentUrl?.find(
                  (doc) => doc?.documentLabelType === field?.label
                ) &&
                !field?.multiple ? (
                  <></>
                ) : (
                  <Upload
                    id={field.id}
                    beforeUpload={() => false}
                    maxCount={1}
                    onChange={
                      handleFileChange &&
                      handleFileChange(field?.labelId, field?.label)
                    }
                    showUploadList={false}
                    disabled={isReadOnly}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      style={{ marginLeft: "10px", width: "100%" }}
                      disabled={isReadOnly}
                    >
                      SELECT FILE
                    </Button>
                  </Upload>
                )}
              </Form.Item>
            </Col>
            <Col
              xs={24}
              md={24}
              sm={24}
              lg={24}
              xl={24}
              style={{ marginBottom: "0.4rem" }}
            >
              {uploadedDocumentUrl && uploadedDocumentUrl?.length > 0 && (
                <Table
                  showHeader={false}
                  dataSource={uploadedDocumentUrl?.filter(
                    (doc) => doc?.documentLabelType === field?.label
                  )}
                  columns={[
                    {
                      title: "Document Type",
                      dataIndex: "documentLabelType",
                      key: "documentType",
                      width: "30%",
                      render: (type: string) => (
                        <Flex justify="center">
                          <Text style={{ color: "#7c8181" }}>{type}</Text>
                        </Flex>
                      ),
                    },
                    {
                      title: "Document Name",
                      dataIndex: "documentName",
                      key: "documentName",
                      width: "30%",

                      render: (name: string) => (
                        <Flex justify="center">
                          <Tooltip title={name}>
                            <Text strong style={{ color: "#7c8181" }}>
                              {name?.length > 20
                                ? name?.substring(0, 20) + "..."
                                : name}
                            </Text>
                          </Tooltip>
                        </Flex>
                      ),
                      // width: 520,
                    },
                    {
                      title: "Actions",
                      key: "actions",
                      width: "40%",
                      render: (_, document, i) => (
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            justifyContent: "center",
                          }}
                        >
                          {isDownloadingDocument && downloadingDocumentUrl === document?.documentUrl ? <LoadingOutlined style={{color: "#273881", fontSize: "18px"}}/> :
                            <Tooltip title="Download File">
                              <DownloadOutlined
                                style={{
                                  color: "#273881",
                                  fontSize: "18px",
                                }}
                                onClick={() =>
                                  handleDownloadDocument &&
                                  handleDownloadDocument(
                                    document?.documentName,
                                    document?.documentUrl
                                  )
                                }
                              />
                            </Tooltip>
                          }
                          <Tooltip title="View File">
                            <EyeOutlined
                              style={{
                                color: "#273881",
                                fontSize: "18px",
                              }}
                              onClick={() => {
                                handleOpen && handleOpen();
                                handleSetDocumentUrl &&
                                  handleSetDocumentUrl(document?.documentUrl);
                              }}
                            />
                          </Tooltip>
                          {!(
                            document?.documentLabelType
                              ?.toLocaleUpperCase()
                              .includes("ECHS CARD") ||
                            document?.documentLabelType
                              ?.toLocaleUpperCase()
                              .includes("REFERRAL LETTER")
                          ) && (
                            <Tooltip title="Delete File">
                              <DeleteOutlined
                                style={{
                                  color: isReadOnly ? "grey" : "#273881",
                                  fontSize: "18px",
                                  cursor: isReadOnly
                                    ? "not-allowed"
                                    : "pointer",
                                }}
                                onClick={
                                  !isReadOnly
                                    ? () =>
                                        handleDeleteList &&
                                        handleDeleteList(
                                          document?.documentLabelType,
                                          document?.documentUrl,
                                          i
                                        )
                                    : undefined
                                }
                              />
                            </Tooltip>
                          )}
                          {document?.deficiencyCheckStatus ? (
                            <Button
                              onClick={() => {
                                if (document && document?.documentName) {
                                  setDocumentName(document?.documentName);
                                }
                                if (document?.documentType) {
                                  handleDeficiencyModal(
                                    document?.documentUrl,
                                    parseInt(document?.documentType),
                                    document
                                  );
                                }
                              }}
                              type="primary"
                              style={{ backgroundColor: "rgb(0, 109, 119)" }}
                            >
                              DEFICIENCY PASSED
                            </Button>
                          ) : document?.deficiencyCheckStatus === false ? (
                            <Button
                              onClick={() => {
                                if (document && document?.documentName) {
                                  setDocumentName(document?.documentName);
                                }
                                if (document?.documentType) {
                                  handleDeficiencyModal(
                                    document?.documentUrl,
                                    parseInt(document?.documentType),
                                    document
                                  );
                                }
                              }}
                              type="primary"
                              danger
                            >
                              DEFICIENCY FAILED
                            </Button>
                          ) : (
                            (Array?.isArray(deficiencyQuestions) ||
                              typeof deficiencyQuestions === "object") && (
                              <Button
                                onClick={() => {
                                  if (document && document?.documentName) {
                                    setDocumentName(document?.documentName);
                                  }
                                  if (document?.documentType) {
                                    handleDeficiencyModal(
                                      document?.documentUrl,
                                      parseInt(document?.documentType),
                                      document
                                    );
                                  }
                                }}
                                type="primary"
                              >
                                DEFICIENCY CHECK
                              </Button>
                            )
                          )}
                        </div>
                      ),
                    },
                  ]}
                  rowKey={(record) =>
                    record.documentName || `document-${record.documentUrl}`
                  }
                  pagination={false}
                  className="showUploadDoc"
                />
              )}
            </Col>
          </Row>
        );

      case "radio-button":
        if (
          (field.id === "routineDischarge" && isTypeOfDischarge) ||
          (field.id === "assuredBy" && isRoutineDischarge)
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Radio.Group defaultValue={field?.data}>
                  {field?.labelValues?.map(
                    (option: { label: string; value: string }) => (
                      <Radio
                        key={option.value}
                        value={option.value}
                        disabled={isReadOnly}
                        onChange={(e) =>
                          onFieldChange &&
                          onFieldChange(index, field.id, e.target.value)
                        }
                      >
                        {option.label?.toUpperCase()}
                      </Radio>
                    )
                  )}
                </Radio.Group>
              </Form.Item>
            </Col>
          );
        } else if (
          (field?.id === "routineDischarge" && !isTypeOfDischarge) ||
          (field.id === "assuredBy" && !isRoutineDischarge)
        )
          return null;
        else if (
          field?.id?.toLowerCase()?.includes("routine") ||
          field?.id?.toLowerCase()?.includes("assuredby")
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Radio.Group defaultValue={field?.data}>
                  {field?.labelValues?.map(
                    (option: { label: string; value: string }) => (
                      <Radio
                        key={option.value}
                        value={option.value}
                        disabled={isReadOnly}
                        onChange={(e) =>
                          onFieldChange &&
                          onFieldChange(index, field.id, e.target.value)
                        }
                      >
                        {option.label?.toUpperCase()}
                      </Radio>
                    )
                  )}
                </Radio.Group>
              </Form.Item>
              );
            </Col>
          );
        } else if (
          field?.id !== "routineDischarge" ||
          field?.id !== "assuredBy"
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Radio.Group defaultValue={field?.data}>
                  {field?.labelValues?.map(
                    (option: { label: string; value: string }) => (
                      <Radio
                        key={option.value}
                        value={option.value}
                        disabled={isReadOnly}
                        onChange={(e) =>
                          onFieldChange &&
                          onFieldChange(index, field.id, e.target.value)
                        }
                      >
                        {option.label?.toUpperCase()}
                      </Radio>
                    )
                  )}
                </Radio.Group>
              </Form.Item>
            </Col>
          );
        }
        return null;

      case "checkbox":
        if (field?.id === "checkbox1" && caseSubmissionId) {
          return null;
        } else {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                // label={field.label?.toUpperCase()}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
                style={{ fontWeight: "600" }}
              >
                <Checkbox
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.checked?.toString())
                  }
                >
                  {field?.label}
                </Checkbox>
              </Form.Item>
            </Col>
          );
        }
      case "calendar-show":
        if (
          field.id === "dateOfDischarge" ||
          field.id === "DateOfDischarge" ||
          field.id === "billDate"
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field.id}
                name={field?.id}
                label={field.label}
                rules={[
                  {
                    required: field?.required,
                    message: "This field is required",
                  },
                ]}
                style={{
                  marginBottom: "8px",
                  fontWeight: "600",
                  width: "100%",
                }}
              >
                {isReadOnly ? (
                  <Text>
                    {/^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/.test(field?.data)
                      ? field.data
                      : field?.data
                      ? dayjs(field.data).format("DD-MM-YYYY HH:mm:ss")
                      : "No Date Available"}
                  </Text>
                ) : (
                  <DatePicker
                    id={field.id}
                    defaultValue={
                      field?.data ? dayjs(field?.data, dateFormat) : null
                    }
                    showTime
                    format={dateFormat}
                    style={{ width: "100%" }}
                    // value={dayjs(field.data, dateFormat)}
                    onChange={(date, dateString) =>
                      onFieldChange &&
                      onFieldChange(index, field.id, dateString as string)
                    }
                  />
                )}
              </Form.Item>
            </Col>
          );
        }
        return (
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Form.Item
              initialValue={value || field.data || ""}
              key={field.id}
              name="date"
              label={field.label}
              rules={[
                {
                  required: field?.required,
                  message: "This field is required",
                },
              ]}
              style={{ marginBottom: "8px", fontWeight: "600", width: "100%" }}
            >
              {isReadOnly ||
              field.id === "ReceivedQuery" ||
              field?.id === "dateOfAdmission" ? (
                // <Text>{value || field.data}</Text>
                <DatePicker
                  id={field.id}
                  defaultValue={
                    field?.data ? dayjs(field?.data, dateFormat) : null
                  }
                  showTime
                  format={dateFormat}
                  // style={{ width: "100%" }}
                  // value={dayjs(field.data, dateFormat)}
                  onChange={(date, dateString) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, dateString as string)
                  }
                  // disabledDate={(current) => {
                  //   return current && current < dayjs();
                  // }}
                  disabled={isReadOnly}
                  style={{ width: "100%" }}
                />
              ) : (
                <DatePicker
                  id={field.id}
                  defaultValue={
                    field?.data ? dayjs(field?.data, dateFormat) : null
                  }
                  showTime
                  format={dateFormat}
                  // style={{ width: "100%" }}
                  // value={dayjs(field.data, dateFormat)}
                  onChange={(date, dateString) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, dateString as string)
                  }
                  disabledDate={(current) => {
                    return current && current < dayjs();
                  }}
                  style={{ width: "100%" }}
                />
              )}
            </Form.Item>
          </Col>
        );

      case "document-dropDown":
        return (
          <DropdownWithFileUpload
            field={field}
            index={index}
            isReadOnly={isReadOnly}
            onFieldChange={onFieldChange}
            handleFileChange={handleFileChange}
            handleOpen={handleOpen}
            handleSetDocumentUrl={handleSetDocumentUrl}
            handleDownloadDocument={handleDownloadDocument}
            uploadedDocumentUrl={uploadedDocumentUrl}
            handleDeleteList={handleDeleteList}
          />
        );

      case "DropDown":
        if (field?.id === "roomType" && key?.toLowerCase()?.includes("star")) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Select
                  showSearch
                  defaultValue={field?.data || `Select ${field?.label}`}
                  options={starHealthRoomTypeOptions?.map((option: any) => ({
                    value: option?.id + "~" + option?.roomType,
                    label: option?.roomType,
                  }))}
                  onChange={(e) =>
                    onFieldChange && onFieldChange(index, field.id, e)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        } else {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Select
                  showSearch
                  defaultValue={field?.data || `Select ${field?.label}`}
                  options={field?.labelValues?.map((option: any) => ({
                    value: option?.value,
                    label: option?.label,
                  }))}
                  onChange={(e) =>
                    onFieldChange && onFieldChange(index, field.id, e)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        }

      case "dropDown":
        if (field?.id === "roomType" && key?.toLowerCase()?.includes("star")) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Select
                  showSearch
                  defaultValue={field?.data || `Select ${field?.label}`}
                  options={starHealthRoomTypeOptions?.map((option: any) => ({
                    value: option?.id + "~" + option?.roomType,
                    label: option?.roomType,
                  }))}
                  onChange={(e) =>
                    onFieldChange && onFieldChange(index, field.id, e)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        } else {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Select
                  showSearch
                  defaultValue={field?.data || `Select ${field?.label}`}
                  options={field?.labelValues?.map((option: any) => ({
                    value: option?.value,
                    label: option?.label,
                  }))}
                  onChange={(e) =>
                    onFieldChange && onFieldChange(index, field.id, e)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        }

      default:
        return null;
    }
  } else {
    switch (field?.type) {
      case "DropDown":
        if (field?.id === "treatingDoctorType") {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Select
                  showSearch
                  defaultValue={field?.data || `Select ${field?.label}`}
                  options={treatingDoctorTypeOptions?.map((option: any) => ({
                    value: option?.value,
                    label: option?.label,
                  }))}
                  onChange={(e) =>
                    onFieldChange && onFieldChange(index, field.id, e)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        } else if (field?.id === "treatingDoctorName") {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Select
                  showSearch
                  defaultValue={field?.data || `Select ${field?.label}`}
                  options={doctorTypeNameList?.map((option: any) => ({
                    value:
                      option?.docName +
                      "~" +
                      option?.docRegn +
                      "~" +
                      option?.docMobile +
                      "~" +
                      option?.docQualification,
                    label: option?.docName,
                  }))}
                  onChange={(e) =>
                    onFieldChange && onFieldChange(index, field.id, e)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        } else {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Select
                  showSearch
                  defaultValue={field?.data || `Select ${field?.label}`}
                  options={field?.labelValues?.map((option: any) => ({
                    value: option?.value,
                    label: option?.label,
                  }))}
                  onChange={(e) =>
                    onFieldChange && onFieldChange(index, field.id, e)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        }
      case "dropDown":
        if (field?.id === "treatingDoctorType") {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Select
                  showSearch
                  defaultValue={field?.data || `Select ${field?.label}`}
                  options={treatingDoctorTypeOptions?.map((option: any) => ({
                    value: option?.value,
                    label: option?.label,
                  }))}
                  onChange={(e) =>
                    onFieldChange && onFieldChange(index, field.id, e)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        } else if (field?.id === "treatingDoctorName") {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Select
                  showSearch
                  defaultValue={field?.data || `Select ${field?.label}`}
                  options={doctorTypeNameList?.map((option: any) => ({
                    value:
                      option?.docName +
                      "~" +
                      option?.docRegn +
                      "~" +
                      option?.docMobile +
                      "~" +
                      option?.docQualification,
                    label: option?.docName,
                  }))}
                  onChange={(e) =>
                    onFieldChange && onFieldChange(index, field.id, e)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        } else {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Select
                  showSearch
                  defaultValue={field?.data || `Select ${field?.label}`}
                  options={field?.labelValues?.map((option: any) => ({
                    value: option?.value,
                    label: option?.label,
                  }))}
                  onChange={(e) =>
                    onFieldChange && onFieldChange(index, field.id, e)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        }
      case "text-show":
        if (field?.id === "treatingDoctorContactNumber") {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                  // {
                  //   pattern: /^\d{10}$/,
                  //   message: "Number must be 10 digits!",
                  // },
                ]}
              >
                <Input
                  defaultValue={field?.data || ""}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                  disabled={true}
                />
              </Form.Item>
            </Col>
          );
        } else if (field?.id === "treatingDoctorRegistrationNo") {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Input
                  defaultValue={field?.data || ""}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                  disabled={true}
                />
              </Form.Item>
            </Col>
          );
        } else if (field?.id === "treatingDoctorQualification") {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Input
                  defaultValue={field?.data || ""}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                  disabled={true}
                />
              </Form.Item>
            </Col>
          );
        } else if (
          (field?.id === "amount" && !isAdditionalAmountPaid) ||
          (field.id === "nameOfAssurer" && !isAssuredBy) ||
          (field.id === "designationOfAssurer" && !isAssuredBy) ||
          (field.id === "relationOfPatientToAssurer" && !isAssuredBy)
        )
          return null;
          else if (
            (field.id === "amount" && isAdditionalAmountPaid)
          ) {
            return (
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Form.Item
                  key={field?.id}
                  name={field?.id}
                  label={field.label?.toUpperCase()}
                  data-tab={tabIndex}
                  wrapperCol={{ span: 8 }}
                  rules={[
                    {
                      required: field?.required,
                      message: `${field?.label} is required`,
                    },
                    {
                      pattern: /^\d+$/,
                      message: "Numeric values are allow!",
                    },
                  ]}
                >
                  <Input
                    defaultValue={field?.data || ""}
                    onChange={(e) =>
                      onFieldChange &&
                      onFieldChange(index, field.id, e.target.value)
                    }
                    disabled={isReadOnly}
                  />
                </Form.Item>
              </Col>
            );
          }
        else if (
          (field.id === "nameOfAssurer" && !isAssuredBy) ||
          (field.id === "designationOfAssurer" && isAssuredBy) ||
          (field.id === "relationOfPatientToAssurer" && isAssuredBy)
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                wrapperCol={{ span: 8 }}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                  // {
                  //   pattern: /^\d+$/,
                  //   message: "Numeric values are allow!",
                  // },
                ]}
              >
                <Input
                  defaultValue={field?.data || ""}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        } else if (
          field?.id?.toLowerCase()?.includes("amount") ||
          field?.id?.toLowerCase()?.includes("nameOfAssurer") ||
          field?.id?.toLowerCase()?.includes("designationOfAssurer") ||
          field?.id?.toLowerCase()?.includes("relationOfPatientToAssurer")
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                wrapperCol={{ span: 8 }}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                  // {
                  //   pattern: /^\d+$/,
                  //   message: "Only Numeric values are allowed!",
                  // },
                ]}
              >
                <Input
                  defaultValue={field?.data || ""}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        } else {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Input
                  defaultValue={field?.data || ""}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        }
      case "input":
        if (
          (field.id === "amount" && isAdditionalAmountPaid) ||
          (field.id === "nameOfAssurer" && isAssuredBy) ||
          (field.id === "designationOfAssurer" && isAssuredBy) ||
          (field.id === "relationOfPatientToAssurer" && isAssuredBy) ||
          (field.id === "assuredBy" && isAssuredBy)
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                wrapperCol={{ span: 8 }}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                  // {
                  //   pattern: /^\d+$/,
                  //   message: "Numeric values are allow!",
                  // },
                ]}
              >
                <Input
                  defaultValue={field?.data || ""}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        } else if (
          (field?.id === "amount" && !isAdditionalAmountPaid) ||
          (field.id === "nameOfAssurer" && !isAssuredBy) ||
          (field.id === "designationOfAssurer" && !isAssuredBy) ||
          (field.id === "relationOfPatientToAssurer" && !isAssuredBy) ||
          (field.id === "assuredBy" && !isAssuredBy)
        )
          return null;
        else if (
          field?.id?.toLowerCase()?.includes("amount") ||
          field?.id?.toLowerCase()?.includes("nameOfAssurence") ||
          field?.id?.toLowerCase()?.includes("designationOfAssurer") ||
          field?.id?.toLowerCase()?.includes("relationOfPatientToAssurer")
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                wrapperCol={{ span: 8 }}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                  {
                    pattern: /^\d+$/,
                    message: "Only Numeric values are allowed!",
                  },
                ]}
              >
                <Input
                  defaultValue={field?.data || ""}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        } else if (
          field?.id !== "amount" ||
          field?.id !== "nameOfAssurence" ||
          field?.id !== "designationOfAssurer" ||
          field?.id !== "relationOfPatientToAssurer"
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Input
                  defaultValue={field?.data || ""}
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.value)
                  }
                  disabled={isReadOnly}
                />
              </Form.Item>
            </Col>
          );
        }
        return null;

      case "document-show":
        return (
          <Row style={{ width: "100%" }}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={
                  <>
                    {uploadedDocumentUrl?.find(
                      (doc) => doc?.documentLabelType === field?.label
                    ) && field?.required ? (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span
                          style={{
                            display: "inline-block",
                            marginInlineEnd: "4px",
                            color: "#ff4d4f",
                            fontSize: "14px",
                            fontFamily: "SimSun, sans-serif",
                            lineHeight: "1",
                          }}
                        >
                          *
                        </span>{" "}
                        {field.label?.toUpperCase()}
                      </div>
                    ) : (
                      field.label?.toUpperCase()
                    )}
                  </>
                }
                data-tab={tabIndex}
                rules={[
                  {
                    required:
                      !uploadedDocumentUrl?.find(
                        //field?.required
                        (doc) => doc?.documentLabelType === field?.label
                      ) && field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
                // rules={[
                //   {
                //     required: field?.required,
                //     message: `${field?.label} is required`,
                //   },
                // ]}
              >
                {uploadedDocumentUrl &&
                uploadedDocumentUrl?.length > 0 &&
                uploadedDocumentUrl?.find(
                  (doc) => doc?.documentLabelType === field?.label
                ) &&
                !field?.multiple ? (
                  <></>
                ) : (
                  <Upload
                    id={field.id}
                    beforeUpload={() => false}
                    maxCount={1}
                    onChange={
                      handleFileChange &&
                      handleFileChange(field?.labelId, field?.label)
                    }
                    showUploadList={false}
                    disabled={isReadOnly}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      style={{ marginLeft: "10px", width: "100%" }}
                      disabled={isReadOnly}
                    >
                      SELECT FILE
                    </Button>
                  </Upload>
                )}
              </Form.Item>
            </Col>
            <Col
              xs={24}
              md={24}
              sm={24}
              lg={24}
              xl={24}
              style={{ marginBottom: "0.4rem" }}
            >
              {uploadedDocumentUrl && uploadedDocumentUrl?.length > 0 && (
                <Table
                  showHeader={false}
                  dataSource={uploadedDocumentUrl?.filter(
                    (doc) => doc?.documentLabelType === field?.label
                  )}
                  columns={[
                    {
                      title: "Document Type",
                      dataIndex: "documentLabelType",
                      key: "documentType",
                      width: "30%",
                      render: (type: string) => (
                        <Flex justify="center">
                          <Text style={{ color: "#7c8181" }}>{type}</Text>
                        </Flex>
                      ),
                    },
                    {
                      title: "Document Name",
                      dataIndex: "documentName",
                      key: "documentName",
                      width: "30%",

                      render: (name: string) => (
                        <Flex justify="center">
                          <Tooltip title={name}>
                            <Text strong style={{ color: "#7c8181" }}>
                              {name?.length > 20
                                ? name?.substring(0, 20) + "..."
                                : name}
                            </Text>
                          </Tooltip>
                        </Flex>
                      ),
                      // width: 520,
                    },
                    {
                      title: "Actions",
                      key: "actions",
                      width: "40%",
                      render: (_, document, i) => (
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            justifyContent: "center",
                          }}
                        >
                          {isDownloadingDocument && downloadingDocumentUrl === document?.documentUrl ? <LoadingOutlined style={{color: "#273881", fontSize: "18px"}}/> :
                            <Tooltip title="Download File">
                              <DownloadOutlined
                                style={{
                                  color: "#273881",
                                  fontSize: "18px",
                                }}
                                onClick={() =>
                                  handleDownloadDocument &&
                                  handleDownloadDocument(
                                    document?.documentName,
                                    document?.documentUrl
                                  )
                                }
                              />
                            </Tooltip>
                          }
                          <Tooltip title="View File">
                            <EyeOutlined
                              style={{
                                color: "#273881",
                                fontSize: "18px",
                              }}
                              onClick={() => {
                                handleOpen && handleOpen();
                                handleSetDocumentUrl &&
                                  handleSetDocumentUrl(document?.documentUrl);
                              }}
                            />
                          </Tooltip>
                          <Tooltip title="Delete File">
                            <DeleteOutlined
                              style={{
                                color: isReadOnly ? "grey" : "#273881",
                                fontSize: "18px",
                                cursor: isReadOnly ? "not-allowed" : "pointer",
                              }}
                              onClick={
                                !isReadOnly
                                  ? () =>
                                      handleDeleteList &&
                                      handleDeleteList(
                                        document?.documentLabelType,
                                        document?.documentUrl,
                                        i
                                      )
                                  : undefined
                              }
                            />
                          </Tooltip>
                          {document?.deficiencyCheckStatus ? (
                            <Button
                              onClick={() => {
                                if (document && document?.documentName) {
                                  setDocumentName(document?.documentName);
                                }
                                if (document?.documentType) {
                                  handleDeficiencyModal(
                                    document?.documentUrl,
                                    parseInt(document?.documentType),
                                    document
                                  );
                                }
                              }}
                              type="primary"
                              style={{ backgroundColor: "rgb(0, 109, 119)" }}
                            >
                              DEFICIENCY PASSED
                            </Button>
                          ) : document?.deficiencyCheckStatus === false ? (
                            <Button
                              onClick={() => {
                                if (document && document?.documentName) {
                                  setDocumentName(document?.documentName);
                                }
                                if (document?.documentType) {
                                  handleDeficiencyModal(
                                    document?.documentUrl,
                                    parseInt(document?.documentType),
                                    document
                                  );
                                }
                              }}
                              type="primary"
                              danger
                            >
                              DEFICIENCY FAILED
                            </Button>
                          ) : (
                            (Array?.isArray(deficiencyQuestions) ||
                              typeof deficiencyQuestions === "object") && (
                              <Button
                                onClick={() => {
                                  if (document && document?.documentName) {
                                    setDocumentName(document?.documentName);
                                  }
                                  if (document?.documentType) {
                                    handleDeficiencyModal(
                                      document?.documentUrl,
                                      parseInt(document?.documentType),
                                      document
                                    );
                                  }
                                }}
                                type="primary"
                              >
                                DEFICIENCY CHECK
                              </Button>
                            )
                          )}
                        </div>
                      ),
                    },
                  ]}
                  rowKey={(record) =>
                    record.documentName || `document-${record.documentUrl}`
                  }
                  pagination={false}
                  className="showUploadDoc"
                />
              )}
            </Col>
          </Row>
        );

      // case "document-show":
      // const dataSource = field?.data ? [field] : [];

      // const columns = [
      //   {
      //     title: "Document Type",
      //     dataIndex: "label",
      //     key: "documentType",
      //     width: "30%",
      //     render: (type: string) => (
      //       <Flex justify="center">
      //         <Text style={{ color: "#7c8181" }}>{type}</Text>
      //       </Flex>
      //     ),
      //   },
      //   {
      //     title: "Document Name",
      //     dataIndex: "documentName",
      //     key: "documentName",
      //     width: "30%",
      //     render: (name: string) => (
      //       <Flex justify="center">
      //         <Tooltip title={name}>
      //           <Text strong style={{ color: "#7c8181" }}>
      //             {name?.length > 20
      //               ? name?.substring(0, 20) + "..."
      //               : name || "Unnamed Document"}
      //           </Text>
      //         </Tooltip>
      //       </Flex>
      //     ),
      //     // width: 520,
      //   },
      //   {
      //     title: "Actions",
      //     key: "actions",
      //     width: "40%",
      //     render: (_: any, document: any, i: any) => (
      //       <div
      //         style={{
      //           display: "flex",
      //           gap: "10px",
      //           justifyContent: "center",
      //           alignItems: "center",
      //         }}
      //       >
      //         {/* Download Action */}
      //         <Tooltip title="Download File">
      //           <DownloadOutlined
      //             style={{
      //               color: "#273881",
      //               fontSize: "18px",
      //             }}
      //             disabled={isReadOnly}
      //             onClick={() => {
      //               handleDownloadDocument &&
      //                 handleDownloadDocument(
      //                   field?.documentName,
      //                   field?.data
      //                 );
      //             }}
      //           />
      //         </Tooltip>

      //         {/* View Action */}
      //         <Tooltip title="View File">
      //           <EyeOutlined
      //             style={{
      //               color: "#273881",
      //               fontSize: "18px",
      //               marginRight: "4px",
      //             }}
      //             onClick={() => {
      //               handleOpen && handleOpen();

      //               handleSetDocumentUrl && handleSetDocumentUrl(field?.data);
      //             }}
      //           />
      //         </Tooltip>

      //         {/* Delete Action */}
      //         <Tooltip title="Delete File">
      //           <DeleteOutlined
      //             style={{
      //               color: isReadOnly ? "grey" : "#273881",
      //               fontSize: "18px",
      //               cursor: isReadOnly ? "not-allowed" : "pointer",
      //             }}
      //             onClick={
      //               !isReadOnly
      //                 ? () =>
      //                     handleDeleteList &&
      //                     handleDeleteList(field?.label, field?.data, index)
      //                 : undefined
      //             }
      //           />
      //         </Tooltip>

      //         {/* Deficiency Check Buttons */}
      //         {field?.deficiencyCheckStatus ? (
      //           <Button
      //             onClick={() => {
      //               if (field && field?.documentName) {
      //                 setDocumentName && setDocumentName(field?.documentName);
      //               }
      //               if (field?.labelId) {
      //                 handleDeficiencyModalAfterSave &&
      //                   handleDeficiencyModalAfterSave(
      //                     field?.data,
      //                     parseInt(field?.labelId),
      //                     field
      //                   );
      //               }
      //             }}
      //             type="primary"
      //             style={{ backgroundColor: "rgb(0, 109, 119)" }}
      //           >
      //             DEFICIENCY PASSED
      //           </Button>
      //         ) : field?.deficiencyCheckStatus === false ? (
      //           <Button
      //             onClick={() => {
      //               if (field && field?.documentName) {
      //                 setDocumentName && setDocumentName(field?.documentName);
      //               }
      //               if (field?.labelId) {
      //                 handleDeficiencyModalAfterSave &&
      //                   handleDeficiencyModalAfterSave(
      //                     field?.data,
      //                     parseInt(field?.labelId),
      //                     field
      //                   );
      //               }
      //             }}
      //             type="primary"
      //             danger
      //           >
      //             DEFICIENCY FAILED
      //           </Button>
      //         ) : (
      //           (Array.isArray(deficiencyQuestions) ||
      //             typeof deficiencyQuestions === "object") && (
      //             <Button
      //               onClick={() => {
      //                 if (field && field?.documentName) {
      //                   setDocumentName &&
      //                     setDocumentName(field?.documentName);
      //                 }
      //                 if (field?.labelId) {
      //                   handleDeficiencyModalAfterSave &&
      //                     handleDeficiencyModalAfterSave(
      //                       field?.data,
      //                       parseInt(field?.labelId),
      //                       field
      //                     );
      //                 }
      //               }}
      //               type="primary"
      //             >
      //               DEFICIENCY CHECK
      //             </Button>
      //           )
      //         )}
      //       </div>
      //     ),
      //   },
      // ];
      // return (
      //   <Col xs={24} sm={24} md={24} lg={24} xl={24}>
      //     <Form.Item
      //       key={field?.id}
      //       name={field?.id}
      //       label={field.label?.toUpperCase()}
      //       data-tab={tabIndex}
      //       rules={[
      //         {
      //           required: field?.required,
      //           message: `${field?.label} is required`,
      //         },
      //       ]}
      //       style={{ fontWeight: "600" }}
      //       labelCol={{ span: 24 }}
      //       wrapperCol={{ span: 24 }}
      //     >
      //       {field?.data ? (
      //         // <Flex align="center" justify="space-between" gap="small">
      //         //   {field?.documentName}
      //         //   <div>
      //         //     <EyeOutlined
      //         //       style={{
      //         //         color: "#273881",
      //         //         fontSize: "18px",
      //         //         marginRight: "4px",
      //         //       }}
      //         //       onClick={() => {
      //         //         handleOpen && handleOpen();

      //         //         handleSetDocumentUrl &&
      //         //           handleSetDocumentUrl(field?.data);
      //         //       }}
      //         //     />
      //         //     <DownloadOutlined
      //         //       style={{
      //         //         color: "#273881",
      //         //         fontSize: "18px",
      //         //       }}
      //         //       disabled={isReadOnly}
      //         //       onClick={() => {
      //         //         handleDownloadDocument &&
      //         //           handleDownloadDocument(
      //         //             field?.documentName,
      //         //             field?.data
      //         //           );
      //         //       }}
      //         //     />
      //         //     <DeleteOutlined
      //         //       style={{
      //         //         color: isReadOnly ? "grey" : "#273881",
      //         //         fontSize: "18px",
      //         //         cursor: isReadOnly ? "not-allowed" : "pointer",
      //         //       }}
      //         //       onClick={
      //         //         !isReadOnly
      //         //           ? () =>
      //         //               handleDeleteList &&
      //         //               handleDeleteList(field?.label, field?.data, index)
      //         //           : undefined
      //         //       }
      //         //     />
      //         //     {field?.deficiencyCheckStatus ? (
      //         //       <Button
      //         //         onClick={() => {
      //         //           if (field && field?.documentName) {
      //         //             setDocumentName(field?.documentName);
      //         //           }
      //         //           if (field?.labelId) {
      //         //             handleDeficiencyModalAfterSave(
      //         //               field?.data,
      //         //               parseInt(field?.labelId),
      //         //               field
      //         //             );
      //         //           }
      //         //         }}
      //         //         block
      //         //         type="primary"
      //         //         htmlType="submit"
      //         //         style={{ backgroundColor: "#198754" }}
      //         //       >
      //         //         DEFICIENCY PASSED
      //         //       </Button>
      //         //     ) : field?.deficiencyCheckStatus === false ? (
      //         //       <Button
      //         //         onClick={() => {
      //         //           if (field && field?.documentName) {
      //         //             setDocumentName(field?.documentName);
      //         //           }
      //         //           if (field?.labelId) {
      //         //             handleDeficiencyModalAfterSave(
      //         //               field?.data,
      //         //               parseInt(field?.labelId),
      //         //               field
      //         //             );
      //         //           }
      //         //         }}
      //         //         block
      //         //         type="primary"
      //         //         danger
      //         //         htmlType="submit"
      //         //       >
      //         //         DEFICIENCY FAILED
      //         //       </Button>
      //         //     ) : (
      //         //       (Array?.isArray(deficiencyQuestions) ||
      //         //         typeof deficiencyQuestions === "object") && (
      //         //         <Button
      //         //           onClick={() => {
      //         //             if (field && field?.documentName) {
      //         //               setDocumentName(field?.documentName);
      //         //             }
      //         //             if (field?.labelId) {
      //         //               handleDeficiencyModalAfterSave(
      //         //                 field?.data,
      //         //                 parseInt(field?.labelId),
      //         //                 field
      //         //               );
      //         //             }
      //         //           }}
      //         //           block
      //         //           type="primary"
      //         //           htmlType="submit"
      //         //         >
      //         //           DEFICIENCY CHECK
      //         //         </Button>
      //         //       )
      //         //     )}
      //         //     {/* <Button
      //         //       type="link"
      //         //       href={field.data ?? undefined}
      //         //       target="_blank"
      //         //       download
      //         //       icon={<DownloadOutlined />}
      //         //     ></Button> */}
      //         //   </div>
      //         // </Flex>

      //         <Table
      //           dataSource={dataSource}
      //           columns={columns}
      //           rowKey={(record) =>
      //             record.documentName ||
      //             `document-${record.documentUrl}` ||
      //             `record-${Math.random()}`
      //           }
      //           pagination={false}
      //           className="showUploadDoc"
      //           showHeader={false}
      //           locale={{
      //             emptyText: dataSource?.length === 0 ? null : undefined, // Hide "No Data" only when dataSource is empty
      //           }}
      //         />
      //       ) : (
      //         <Upload
      //           id={field.id}
      //           beforeUpload={() => false}
      //           maxCount={1}
      //           onChange={
      //             handleFileChange &&
      //             handleFileChange(field?.labelId, field?.label)
      //           }
      //           showUploadList={false}
      //           disabled={isReadOnly}
      //         >
      //           <Button
      //             icon={<UploadOutlined />}
      //             style={{ marginLeft: "10px", width: "100%" }}
      //             disabled={isReadOnly}
      //           >
      //             SELECT FILE
      //           </Button>
      //         </Upload>
      //       )}
      //     </Form.Item>
      //   </Col>
      // );

      case "document-upload":
        return (
          <Row style={{ width: "100%" }}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                {field?.data ? (
                  <Flex align="center" justify="space-between" gap="small">
                    {field?.documentName}
                    <div>
                      <EyeOutlined
                        style={{
                          color: "#273881",
                          fontSize: "18px",
                          marginRight: "4px",
                        }}
                        onClick={() => {
                          handleOpen && handleOpen();
                          handleSetDocumentUrl &&
                            handleSetDocumentUrl(field?.data);
                        }}
                      />
                      {isDownloadingDocument && downloadingDocumentUrl === field?.data ? <LoadingOutlined style={{color: "#273881", fontSize: "18px"}}/> :
                      <DownloadOutlined
                        style={{
                          color: "#273881",
                          fontSize: "18px",
                        }}
                        onClick={() => {
                          handleDownloadDocument &&
                            handleDownloadDocument(
                              field?.documentName,
                              field?.data
                            );
                        }}
                      />
    }
                      {/* <DeleteOutlined
                        style={{
                          color: "#273881",
                          fontSize: "18px",
                        }}
                        onClick={() =>
                          handleDeleteList &&
                          handleDeleteList(document?.documentType, document?.documentUrl, i)
                        }
                      /> */}
                      {/* <Button
                      type="link"
                      href={field.data ?? undefined}
                      target="_blank"
                      download
                      icon={<DownloadOutlined />}
                    ></Button> */}
                    </div>
                  </Flex>
                ) : (
                  <Upload
                    id={field.id}
                    beforeUpload={() => false}
                    maxCount={1}
                    onChange={
                      handleFileChange &&
                      handleFileChange(field?.labelId, field?.label)
                    }
                    showUploadList={false}
                    disabled={isReadOnly}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      style={{ marginLeft: "10px", width: "100%" }}
                      disabled={isReadOnly}
                    >
                      SELECT FILE
                    </Button>
                  </Upload>
                )}
              </Form.Item>
            </Col>
            {/* <Col xs={24} md={24} sm={24} lg={24} xl={24}>
              {uploadedDocumentUrl &&
                uploadedDocumentUrl?.length > 0 &&
                uploadedDocumentUrl
                  ?.filter((doc) => doc?.documentLabelType === field?.label)
                  ?.map((document, i) => (
                    <div className="file-list-container" key={i}>
                      <ul
                        className="list-unstyled"
                        style={{ marginTop: "0rem" }}
                      >
                        <li className="file-item" style={{ display: "flex" }}>
                          <span className="file-name" style={{ width: "50%" }}>
                            {document?.documentName
                              ? document?.documentName?.length > 20
                                ? document?.documentName?.substring(0, 20) +
                                  "..."
                                : document?.documentName
                              : ""}
                          </span>
                          <Flex
                            // justify="flex-end"
                            align="center"
                            gap="small"
                            className="fa-icons"
                            style={{ width: "20%" }}
                          >
                            <DownloadOutlined
                              style={{
                                color: "#273881",
                                fontSize: "18px",
                              }}
                              onClick={() =>
                                handleDownloadDocument &&
                                handleDownloadDocument(
                                  document?.documentName,
                                  document?.documentUrl
                                )
                              }
                            />
                            <EyeOutlined
                              style={{
                                color: "#273881",
                                fontSize: "18px",
                              }}
                              onClick={() => {
                                handleOpen && handleOpen();
                                handleSetDocumentUrl &&
                                  handleSetDocumentUrl(document?.documentUrl);
                              }}
                            />
                            <DeleteOutlined
                              style={{
                                color: "#273881",
                                fontSize: "18px",
                              }}
                              onClick={() =>
                                handleDeleteList &&
                                handleDeleteList(
                                  document?.documentLabelType,
                                  document?.documentUrl,
                                  i
                                )
                              }
                            />

                            {document?.deficiencyCheckStatus ? (
                              <Button
                                onClick={() => {
                                  if (document && document?.documentName) {
                                    setDocumentName(document?.documentName);
                                  }
                                  if (document?.documentType) {
                                    handleDeficiencyModal(
                                      document?.documentUrl,
                                      parseInt(document?.documentType),
                                      document
                                    );
                                  }
                                }}
                                block
                                type="primary"
                                style={{ backgroundColor: "#198754" }}
                              >
                                DEFICIENCY PASSED
                              </Button>
                            ) : document?.deficiencyCheckStatus === false ? (
                              <Button
                                onClick={() => {
                                  if (document && document?.documentName) {
                                    setDocumentName(document?.documentName);
                                  }
                                  if (document?.documentType) {
                                    handleDeficiencyModal(
                                      document?.documentUrl,
                                      parseInt(document?.documentType),
                                      document
                                    );
                                  }
                                }}
                                block
                                type="primary"
                                danger
                              >
                                DEFICIENCY FAILED
                              </Button>
                            ) : (
                              (Array?.isArray(deficiencyQuestions) ||
                                typeof deficiencyQuestions === "object") && (
                                <Button
                                  onClick={() => {
                                    if (document && document?.documentName) {
                                      setDocumentName(document?.documentName);
                                    }
                                    if (document?.documentType) {
                                      handleDeficiencyModal(
                                        document?.documentUrl,
                                        parseInt(document?.documentType),
                                        document
                                      );
                                    }
                                  }}
                                  block
                                  type="primary"
                                  htmlType="submit"
                                >
                                  DEFICIENCY CHECK
                                </Button>
                              )
                            )}
                          </Flex>
                        </li>
                      </ul>
                    </div>
                  ))}
            </Col> */}
            <Col
              xs={24}
              md={24}
              sm={24}
              lg={24}
              xl={24}
              style={{ marginBottom: "0.4rem" }}
            >
              {uploadedDocumentUrl && uploadedDocumentUrl?.length > 0 && (
                <Table
                  showHeader={false}
                  dataSource={uploadedDocumentUrl?.filter(
                    (doc) =>
                      doc?.documentLabelType === field?.label &&
                      doc?.prefilledData !== true
                  )}
                  columns={[
                    {
                      title: "Document Type",
                      dataIndex: "documentLabelType",
                      key: "documentType",
                      width: "30%",
                      render: (type: string) => (
                        <Flex justify="center">
                          <Text style={{ color: "#7c8181" }}>{type}</Text>
                        </Flex>
                      ),
                    },
                    {
                      title: "Document Name",
                      dataIndex: "documentName",
                      key: "documentName",
                      width: "30%",

                      render: (name: string) => (
                        <Flex justify="center">
                          <Tooltip title={name}>
                            <Text strong style={{ color: "#7c8181" }}>
                              {name?.length > 20
                                ? name?.substring(0, 20) + "..."
                                : name}
                            </Text>
                          </Tooltip>
                        </Flex>
                      ),
                      // width: 520,
                    },
                    {
                      title: "Actions",
                      key: "actions",
                      width: "40%",
                      render: (_, document, i) => (
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            justifyContent: "center",
                          }}
                        >
                          {isDownloadingDocument && downloadingDocumentUrl === document?.documentUrl ? <LoadingOutlined style={{color: "#273881", fontSize: "18px"}}/> :
                            <Tooltip title="Download File">
                              <DownloadOutlined
                                style={{
                                  color: "#273881",
                                  fontSize: "18px",
                                }}
                                onClick={() =>
                                  handleDownloadDocument &&
                                  handleDownloadDocument(
                                    document?.documentName,
                                    document?.documentUrl
                                  )
                                }
                              />
                            </Tooltip>
                          }
                          <Tooltip title="View File">
                            <EyeOutlined
                              style={{
                                color: "#273881",
                                fontSize: "18px",
                              }}
                              onClick={() => {
                                handleOpen && handleOpen();
                                handleSetDocumentUrl &&
                                  handleSetDocumentUrl(document?.documentUrl);
                              }}
                            />
                          </Tooltip>
                          <Tooltip title="Delete File">
                            <DeleteOutlined
                              style={{
                                color: "#273881",
                                fontSize: "18px",
                              }}
                              onClick={() =>
                                handleDeleteList &&
                                handleDeleteList(
                                  document?.documentLabelType,
                                  document?.documentUrl,
                                  i
                                )
                              }
                            />
                          </Tooltip>
                          {document?.deficiencyCheckStatus ? (
                            <Button
                              onClick={() => {
                                if (document && document?.documentName) {
                                  setDocumentName(document?.documentName);
                                }
                                if (document?.documentType) {
                                  handleDeficiencyModal(
                                    document?.documentUrl,
                                    parseInt(document?.documentType),
                                    document
                                  );
                                }
                              }}
                              type="primary"
                              style={{ backgroundColor: "rgb(0, 109, 119)" }}
                            >
                              DEFICIENCY PASSED
                            </Button>
                          ) : document?.deficiencyCheckStatus === false ? (
                            <Button
                              onClick={() => {
                                if (document && document?.documentName) {
                                  setDocumentName(document?.documentName);
                                }
                                if (document?.documentType) {
                                  handleDeficiencyModal(
                                    document?.documentUrl,
                                    parseInt(document?.documentType),
                                    document
                                  );
                                }
                              }}
                              type="primary"
                              danger
                            >
                              DEFICIENCY FAILED
                            </Button>
                          ) : (
                            (Array?.isArray(deficiencyQuestions) ||
                              typeof deficiencyQuestions === "object") && (
                              <Button
                                onClick={() => {
                                  if (document && document?.documentName) {
                                    setDocumentName(document?.documentName);
                                  }
                                  if (document?.documentType) {
                                    handleDeficiencyModal(
                                      document?.documentUrl,
                                      parseInt(document?.documentType),
                                      document
                                    );
                                  }
                                }}
                                type="primary"
                                htmlType="submit"
                              >
                                DEFICIENCY CHECK
                              </Button>
                            )
                          )}
                        </div>
                      ),
                    },
                  ]}
                  rowKey={(record) =>
                    record.documentName || `document-${record.documentUrl}`
                  }
                  pagination={false}
                  className="showUploadDoc"
                />
              )}
            </Col>
          </Row>
        );
      case "radio button":
        if (
          (field.id === "routineDischarge" && isTypeOfDischarge) ||
          (field.id === "assuredBy" && isRoutineDischarge)
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Radio.Group defaultValue={field?.data}>
                  {field?.labelValues?.map(
                    (option: { label: string; value: string }) => (
                      <Radio
                        key={option.value}
                        value={option.value}
                        disabled={isReadOnly}
                        onChange={(e) =>
                          onFieldChange &&
                          onFieldChange(index, field.id, e.target.value)
                        }
                      >
                        {option.label?.toUpperCase()}
                      </Radio>
                    )
                  )}
                </Radio.Group>
              </Form.Item>
              );
            </Col>
          );
        } else if (
          (field?.id === "routineDischarge" && !isTypeOfDischarge) ||
          (field.id === "assuredBy" && !isRoutineDischarge)
        )
          return null;
        else if (field?.id?.toLowerCase()?.includes("Routine")) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Radio.Group defaultValue={field?.data}>
                  {field?.labelValues?.map(
                    (option: { label: string; value: string }) => (
                      <Radio
                        key={option.value}
                        value={option.value}
                        disabled={isReadOnly}
                        onChange={(e) =>
                          onFieldChange &&
                          onFieldChange(index, field.id, e.target.value)
                        }
                      >
                        {option.label?.toUpperCase()}
                      </Radio>
                    )
                  )}
                </Radio.Group>
              </Form.Item>
              );
            </Col>
          );
        } else if (field?.id !== "routineDischarge") {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Radio.Group defaultValue={field?.data}>
                  {field?.labelValues?.map(
                    (option: { label: string; value: string }) => (
                      <Radio
                        key={option.value}
                        value={option.value}
                        disabled={isReadOnly}
                        onChange={(e) =>
                          onFieldChange &&
                          onFieldChange(index, field.id, e.target.value)
                        }
                      >
                        {option.label?.toUpperCase()}
                      </Radio>
                    )
                  )}
                </Radio.Group>
              </Form.Item>
            </Col>
          );
        }
        return null;

      case "radio-button":
        if (
          (field.id === "routineDischarge" && isTypeOfDischarge) ||
          (field.id === "assuredBy" && isRoutineDischarge)
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Radio.Group defaultValue={field?.data}>
                  {field?.labelValues?.map(
                    (option: { label: string; value: string }) => (
                      <Radio
                        key={option.value}
                        value={option.value}
                        disabled={isReadOnly}
                        onChange={(e) =>
                          onFieldChange &&
                          onFieldChange(index, field.id, e.target.value)
                        }
                      >
                        {option.label?.toUpperCase()}
                      </Radio>
                    )
                  )}
                </Radio.Group>
              </Form.Item>
            </Col>
          );
        } else if (
          (field?.id === "routineDischarge" && !isTypeOfDischarge) ||
          (field.id === "assuredBy" && !isRoutineDischarge)
        )
          return null;
        else if (field?.id?.toLowerCase()?.includes("Routine")) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Radio.Group defaultValue={field?.data}>
                  {field?.labelValues?.map(
                    (option: { label: string; value: string }) => (
                      <Radio
                        key={option.value}
                        value={option.value}
                        disabled={isReadOnly}
                        onChange={(e) =>
                          onFieldChange &&
                          onFieldChange(index, field.id, e.target.value)
                        }
                      >
                        {option.label?.toUpperCase()}
                      </Radio>
                    )
                  )}
                </Radio.Group>
              </Form.Item>
            </Col>
          );
        } else if (field?.id !== "routineDischarge") {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                <Radio.Group defaultValue={field?.data}>
                  {field?.labelValues?.map(
                    (option: { label: string; value: string }) => (
                      <Radio
                        key={option.value}
                        value={option.value}
                        disabled={isReadOnly}
                        onChange={(e) =>
                          onFieldChange &&
                          onFieldChange(index, field.id, e.target.value)
                        }
                      >
                        {option.label?.toUpperCase()}
                      </Radio>
                    )
                  )}
                </Radio.Group>
              </Form.Item>
            </Col>
          );
        }
        return null;

      case "calendar-show":
        if (
          field?.id === "dateOfDischarge" &&
          key?.toLowerCase()?.includes("cghs")
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                {isReadOnly ? (
                  <Text>{value || field.data}</Text>
                ) : (
                  <DatePicker
                    defaultValue={
                      field?.data ? dayjs(field?.data, dateFormat) : null
                    }
                    disabled={isReadOnly}
                    showTime
                    format={dateFormat}
                    style={{ width: "100%" }}
                    onChange={(date, dateString) =>
                      onFieldChange &&
                      onFieldChange(index, field.id, dateString as string)
                    }
                    minuteStep={5}
                    allowClear={false}
                    inputReadOnly={false}
                    disabledDate={(currentDate) =>
                      currentDate &&
                      currentDate < dayjs(field?.visitDoa, dateFormat)
                    }
                  />
                )}
              </Form.Item>
            </Col>
          );
        } else if (
          field?.id === "dischargeFollowUpDate" &&
          key?.toLowerCase()?.includes("cghs")
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                {isReadOnly ? (
                  <Text>{value || field.data}</Text>
                ) : (
                  <DatePicker
                    defaultValue={
                      field?.data ? dayjs(field?.data, dateFormat) : null
                    }
                    disabled={isReadOnly}
                    showTime
                    format={dateFormat}
                    style={{ width: "100%" }}
                    onChange={(date, dateString) =>
                      onFieldChange &&
                      onFieldChange(index, field.id, dateString as string)
                    }
                    allowClear={false}
                    inputReadOnly={false}
                    disabledDate={(currentDate) =>
                      currentDate &&
                      currentDate <
                        dayjs(form.getFieldValue("dateOfDischarge"), dateFormat)
                    }
                  />
                )}
              </Form.Item>
            </Col>
          );
        } else if (
          field?.id === "surgeryDate" &&
          key?.toLowerCase()?.includes("cghs")
        ) {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                {isReadOnly ? (
                  <Text>{value || field.data}</Text>
                ) : (
                  <DatePicker
                    defaultValue={
                      field?.data ? dayjs(field?.data, dateFormat) : null
                    }
                    disabled={isReadOnly}
                    showTime
                    format={dateFormat}
                    style={{ width: "100%" }}
                    onChange={(date, dateString) =>
                      onFieldChange &&
                      onFieldChange(index, field.id, dateString as string)
                    }
                    allowClear={false}
                    inputReadOnly={false}
                    disabledDate={(currentDate) =>
                      currentDate &&
                      currentDate < dayjs(field?.visitDoa, dateFormat)
                    }
                  />
                )}
              </Form.Item>
            </Col>
          );
        } else if (field?.id === "dateOfDischarge") {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                {isReadOnly ? (
                  <Text>{value || field.data}</Text>
                ) : (
                  <DatePicker
                    defaultValue={
                      field?.data ? dayjs(field?.data, dateFormat) : null
                    }
                    disabled={isReadOnly}
                    showTime
                    format={dateFormat}
                    style={{ width: "100%" }}
                    onChange={(date, dateString) =>
                      onFieldChange &&
                      onFieldChange(index, field.id, dateString as string)
                    }
                    minuteStep={5}
                    allowClear={false}
                    inputReadOnly={false}
                  />
                )}
              </Form.Item>
            </Col>
          );
        } else {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                label={field.label?.toUpperCase()}
                data-tab={tabIndex}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
              >
                {isReadOnly ? (
                  <Text>{value || field.data}</Text>
                ) : (
                  <DatePicker
                    defaultValue={
                      field?.data ? dayjs(field?.data, dateFormat) : null
                    }
                    disabled={isReadOnly}
                    showTime
                    format={dateFormat}
                    style={{ width: "100%" }}
                    onKeyDown={onKeyDown}
                    onChange={(date, dateString) =>
                      onFieldChange &&
                      onFieldChange(index, field.id, dateString as string)
                    }
                    allowClear={false}
                    inputReadOnly={false}
                  />
                )}
              </Form.Item>
            </Col>
          );
        }
      case "checkbox":
        if (field?.id === "checkbox1" && caseSubmissionId) {
          return null;
        } else {
          return (
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Form.Item
                key={field?.id}
                name={field?.id}
                // label={field.label?.toUpperCase()}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: field?.required,
                    message: `${field?.label} is required`,
                  },
                ]}
                style={{ fontWeight: "500" }}
              >
                <Checkbox
                  onChange={(e) =>
                    onFieldChange &&
                    onFieldChange(index, field.id, e.target.checked?.toString())
                  }
                  className="custom-dark-checkbox"
                >
                  {field?.label}
                </Checkbox>
              </Form.Item>
            </Col>
          );
        }
      default:
        return null;
    }
  }
};
